// ur translations
export const UR_TRANSLATIONS: { [key: string]: string } = {


    "--DropoffLateReason": "-- ڈراپ آف تاخیر کی وجہ --",
    "--FundingSource--": "-- فنڈنگ ​​کا ذریعہ --",
    "--PickupLateReason": "-- پک اپ میں تاخیر کی وجہ --",
    "--Seats--": "-- نشستیں --",
    "--Select--": "-- منتخب --",
    "--SelectAccountStatus": "-- اکاؤنٹ کی حیثیت منتخب کریں --",
    "--SelectAssist--": "-- اسسٹ کو منتخب کریں --",
    "--SelectBodyType": "-- باڈی ٹائپ منتخب کریں --",
    "--SelectBroker--": "-- بروکر کو منتخب کریں --",
    "--SelectCancelReasons": "-- منسوخی کی وجوہات کو منتخب کریں --",
    "--SelectCapacity--": "-- صلاحیت منتخب کریں --",
    "--SelectCompetency--": "-- قابلیت منتخب کریں --",
    "--SelectCorporateUser": "-- کارپوریٹ صارف کو منتخب کریں --",
    "--SelectDateFormat": "-- تاریخ کی شکل منتخب کریں --",
    "--SelectDay--": "-- دن منتخب کریں --",
    "--SelectDiagnosismedicalCond": "-- تشخیص/طبی حالت کا انتخاب کریں --",
    "--SelectDoModifier": "-- ڈی او موڈیفائر کو منتخب کریں --",
    "--SelectDrivers--": "-- ڈرائیور منتخب کریں --",
    "--SelectDrivers--2": "-- ڈرائیور منتخب کریں --",
    "--SelectEmploymentType": "-- روزگار کی قسم منتخب کریں --",
    "--SelectEquipment--": "-- سامان منتخب کریں --",
    "--SelectFleet--": "-- بیڑے کو منتخب کریں --",
    "--SelectFs--": "-- FS منتخب کریں --",
    "--SelectFuelType": "-- ایندھن کی قسم منتخب کریں --",
    "--SelectGroup--": "-- گروپ منتخب کریں --",
    "--SelectMapper--": "-- میپر کو منتخب کریں --",
    "--SelectMemberRole": "-- ممبر رول منتخب کریں --",
    "--SelectMethod--": "-- طریقہ منتخب کریں --",
    "--SelectMonth--": "-- مہینہ منتخب کریں --",
    "--SelectOperationsManager": "-- آپریشنز مینیجر کو منتخب کریں --",
    "--SelectPlatformportal--": "-- پلیٹ فارم/پورٹل کو منتخب کریں --",
    "--SelectPosition--": "-- پوزیشن منتخب کریں --",
    "--SelectProficiency--": "-- مہارت کو منتخب کریں --",
    "--SelectPuModifier": "-- PU موڈیفائر کو منتخب کریں --",
    "--SelectReason--": "-- وجہ منتخب کریں --",
    "--SelectRoleType": "-- رول کی قسم منتخب کریں --",
    "--SelectServiceAreas": "-- سروس ایریا منتخب کریں --",
    "--SelectShiftAlign": "-- شفٹ الائن کو منتخب کریں --",
    "--SelectSpacetype--": "-- خلائی قسم کو منتخب کریں --",
    "--SelectStateCode": "-- ریاستی کوڈ کو منتخب کریں --",
    "--SelectStationManager": "-- سٹیشن مینیجر کو منتخب کریں --",
    "--SelectStatus--": "-- سٹیٹس منتخب کریں --",
    "--SelectStatuss--": "-- سٹیٹس کو منتخب کریں --",
    "--SelectTemplate--": "-- ٹیمپلیٹ منتخب کریں --",
    "--SelectTimeFormat": "-- ٹائم فارمیٹ منتخب کریں --",
    "--SelectType--": "-- قسم منتخب کریں --",
    "--SelectVehicle--": "-- گاڑی منتخب کریں --",
    "--ServiceArea--": "--سروس ایریا --",
    "--SpaceType--": "-- خلائی قسم --",
    "--selectRequiredOdometer--": "-- مطلوبہ اوڈومیٹر کو منتخب کریں --",
    "--selectStatus--": "-- سٹیٹس کو منتخب کریں --",
    "-selectFundingSource-": "فنڈنگ ​​کا ذریعہ منتخب کریں-",
    "10min": "10 منٹ",
    "15min": "15 منٹ",
    "1HourViolation": "1 گھنٹے کی خلاف ورزی",
    "30min": "30 منٹ",
    "Amendments": "ترمیمات",
    "Announcement": "اعلان",
    "Cities Zones": "شہر زونز",
    "Companies": "کمپنیاں",
    "Drivers": "ڈرائیورز",
    "Drivers Load": "ڈرائیورز لوڈ",
    "Equipment Planning": "آلات کی منصوبہ بندی",
    "Equipments": "آلات",
    "Funding Sources": "فنڈنگ سورسز",
    "Holidays": "چھٹیاں",
    "Late Forecast": "لیٹ فورکاسٹ",
    "Late Reasons": "تاخیر کی وجوہات",
    "Level of Service": "لیول آف سروس",
    "Mapper": "میپر",
    "Members": "ممبرز",
    "Miles For Bucks": "مائلز فار بکس",
    "New Trip": "نیا سفر",
    "Offered": "پیش کردہ",
    "Payors": "پیئرز",
    "Profiling": "پروفائلنگ",
    "Quarters": "کوارٹرز",
    "Schedule": "شیڈول",
    "Service Areas": "سروس ایریا",
    "Shift Override": "شفٹ اووررائیڈ",
    "Space Type Checklist": "اسپیس ٹائپ چیک لسٹ",
    "Space Types": "اسپیس ٹائپس",
    "Staff": "عملہ",
    "Standing Orders": "اسٹینڈنگ آرڈرز",
    "Templates": "ٹیمپلیٹس",
    "Timesheet": "ٹائم شیٹ",
    "Trip Sheet": "ٹرپ شیٹ",
    "Vehicles": "گاڑیاں",
    "Violations": "خلاف ورزیاں",
    "aaccountStatusIsRequired": "اکاؤنٹ کی حیثیت درکار ہے۔",
    "accept": "قبول کریں۔",
    "accepted": "قبول کر لیا",
    "acceptedTrips": "قبول شدہ سفر",
    "accidentAndIncidentTraining": "حادثہ اور حادثہ کی تربیت",
    "accountStatus": "اکاؤنٹ کی حیثیت",
    "accountStatusIsRequired": "اکاؤنٹ کی حیثیت درکار ہے۔",
    "acknowledgeByDriver": "ڈرائیور کی طرف سے تسلیم",
    "act": "ایکٹ",
    "action": "ایکشن",
    "actions": "اعمال",
    "actualShift": "اصل شفٹ",
    "add": "+ شامل کریں۔",
    "addAddon": "ایڈون شامل کریں۔",
    "addAmendment": "ترمیم شامل کریں۔",
    "addAnnouncement": "اعلان شامل کریں۔",
    "addAppointmentType": "ملاقات کی قسم شامل کریں۔",
    "addBeneficiary": "فائدہ اٹھانے والے کو شامل کریں۔",
    "addBreak": "وقفہ شامل کریں۔",
    "addBroker": "بروکر شامل کریں۔",
    "addCancelReason": "منسوخی کی وجہ شامل کریں۔",
    "addChecklist": "چیک لسٹ شامل کریں۔",
    "addCity": "شہر شامل کریں۔",
    "addCompany": "کمپنی شامل کریں۔",
    "addDistribution": "تقسیم شامل کریں۔",
    "addDriver": "ڈرائیور شامل کریں۔",
    "addEquipment": "سامان شامل کریں۔",
    "addFundingSource": "فنڈنگ ​​کا ذریعہ شامل کریں۔",
    "addHoliday": "تعطیلات شامل کریں۔",
    "addLegButton": "+ مرحلہ",
    "addLevelOfService": "سروس کی سطح شامل کریں۔",
    "addMapper": "میپر شامل کریں۔",
    "addMember": "ممبر شامل کریں۔",
    "addModifierCode": "موڈیفائر کوڈ شامل کریں۔",
    "addPayor": "Payor شامل کریں۔",
    "addPrimaryDiagnose": "بنیادی تشخیص شامل کریں۔",
    "addQuarter": "کوارٹر شامل کریں۔",
    "addRate": "ریٹ شامل کریں۔",
    "addReason": "وجہ شامل کریں۔",
    "addServiceArea": "سروس ایریا شامل کریں۔",
    "addShift": "شفٹ شامل کریں۔",
    "addShiftOverride": "شفٹ اوور رائڈ شامل کریں۔",
    "addSpaceType": "جگہ کی قسم شامل کریں۔",
    "addStaff": "عملہ شامل کریں۔",
    "addTemplate": "ٹیمپلیٹ شامل کریں۔",
    "addTips": "تجاویز شامل کریں۔",
    "addTripHeader": "شامل کریں",
    "addVehicle": "گاڑی شامل کریں۔",
    "addYourComment": "اپنا تبصرہ شامل کریں۔",
    "addYourComment2": "اپنا تبصرہ شامل کریں...",
    "addZone": "زون شامل کریں۔",
    "additionalInformation": "اضافی معلومات",
    "additionalNote": "اضافی نوٹ",
    "addonButton": "+ اضافی آئٹم",
    "addonItemLabel": "آئٹم",
    "addonItemRequired": "آئٹم مطلوب ہے",
    "addonServicesHeader": "اضافی سروسز",
    "address": "پتہ:",
    "addressLabel": "پتہ",
    "addressName": "پتہ کا نام",
    "addressNameIsRequired": "ایڈریس کا نام درکار ہے۔",
    "addressRequired": "پتہ مطلوب ہے",
    "addressValidationAlert": "ایڈریس کی توثیق کا انتباہ",
    "addupdateSignature": "دستخط شامل کریں/اپ ڈیٹ کریں۔",
    "adjustTrip": "ٹرپ کو ایڈجسٹ کریں۔",
    "adjustment": "ایڈجسٹمنٹ",
    "adlAmbulanceDriversLicense": "ADL (ایمبولینس ڈرائیور لائسنس)",
    "adlImageIsRequired": "ADL تصویر درکار ہے۔",
    "admin": "ایڈمن",
    "agent": "ایجنٹ",
    "alarming": "تشویشناک",
    "alarmingTrips": "تشویشناک سفر",
    "alcReminder": "ALC یاد دہانی",
    "alcoholScreeningRecentScreen": "الکحل کی اسکریننگ (حالیہ اسکریننگ)",
    "algorithm": "الگورتھم",
    "all": "تمام",
    "allDrivers": "تمام ڈرائیورز",
    "allMessages": "تمام پیغامات",
    "allNotifications": "تمام اطلاعات",
    "allowAttendee": "حاضری کی اجازت دیں۔",
    "allowAuthorizationNumberFor": "ایک کیئر کے لیے اجازت نمبر کی اجازت دیں۔",
    "allowPlacement": "پلیسمینٹ کی اجازت دیں",
    "allowCamera": "کیمرے کی اجازت دیں۔",
    "allowCapacityViolation": "صلاحیت کی خلاف ورزی کی اجازت دیں۔",
    "allowCapacityViolations": "صلاحیت کی خلاف ورزی کی اجازت دیں",
    "allowIncentive": "حوصلہ افزائی کی اجازت دیں۔",
    "allowIpcr": "آئی پی سی آر کی اجازت دیں۔",
    "allowAuditLogs": "آڈٹ لاگز کی اجازت دیں",
    "allowCoverage": "کوریج کی اجازت دیں",
    "auditlogs": "آڈٹ لاگز",
    "allowMulti-factorAuthenticat": "ملٹی فیکٹر توثیق کی اجازت دیں۔",
    "allowNearBy": "قریب کی اجازت دیں۔",
    "allowOnboardViolations": "آن بورڈ خلاف ورزیوں کی اجازت دیں",
    "allowPossibility": "امکان کی اجازت دیں۔",
    "allowSms": "ایس ایم ایس کی اجازت دیں۔",
    "allowTimesheet": "ٹائم شیٹ کی اجازت دیں۔",
    "allowVoiceAssistance": "صوتی مدد کی اجازت دیں۔",
    "ambulance": "ایمبولینس",
    "ambulette": "ایمبولیٹ",
    "amendment": "ترمیم",
    "amountIsRequired": "رقم درکار ہے۔",
    "announcements": "اعلانات",
    "api": "API",
    "appealed": "اپیل کی۔",
    "appky": "اپکی",
    "applyIncentive": "ترغیب کا اطلاق کریں۔",
    "appointmentDirectionInside": "مرکز کے اندر",
    "appointmentDirectionLabel": "ملاقات کی سمت",
    "appointmentDirectionOutside": "مرکز سے باہر",
    "appointmentTime": "ملاقات کا وقت",
    "appointmentTimeIsRequired": "ملاقات کا وقت درکار ہے۔",
    "appointmentTypeLabel": "ملاقات کی قسم ",
    "appointmentTypeRequired": "ملاقات کی قسم مطلوب ہے",
    "appointmentTypefileIsRequire": "تقرری کی قسم (فائل) درکار ہے۔",
    "appointmentTypetpIsRequired": "تقرری کی قسم (TP) درکار ہے۔",
    "approachingAlert": "الرٹ کے قریب",
    "approachingTrips": "آنے والے سفر",
    "approve": "منظور کرو",
    "approved": "منظور شدہ",
    "aptOrSuiteIs": "APT یا سویٹ درکار ہے۔",
    "aptOrSuiteLabel": "فلیٹ / سویٹ",
    "aptOrSuiteRequired": "فلیٹ / سویٹ مطلوب ہے",
    "aptsuiteroom": "اپٹ/سویٹ/کمرہ",
    "arabicLanguageLabel": "العربية",
    "archive": "محفوظ شدہ دستاویزات",
    "archived": "محفوظ شدہ",
    "archivedTrips": "آرکائیو شدہ سفر",
    "areYouSureYou": "کیا آپ واقعی اس دورے کو ایک نئے وقت میں منتقل کرنا چاہتے ہیں؟",
    "areYouSureYou2": "کیا آپ واقعی منسوخ کرنا چاہتے ہیں؟",
    "areYouSureYou3": "کیا آپ واقعی اوڈومیٹر کو اپ ڈیٹ کرنا چاہتے ہیں؟",
    "areYouSureYou4": "کیا آپ واقعی اس مخصوص تاریخ پر پیرنٹ اسٹینڈنگ آرڈر سے ٹرپ بنانا چاہتے ہیں؟",
    "areYouSureYou5": "کیا آپ واقعی سسٹم سے تمام ٹرپس ڈیٹا کو صاف کرنا چاہتے ہیں؟ ڈرائیور کو کوئی سفر تفویض کرنے کے لیے آپ کو دوبارہ ڈیٹا دوبارہ درآمد کرنا پڑے گا کیونکہ یہ ایک مستقل کارروائی ہے؟",
    "arn": "اے آر این",
    "arrears": "بقایا جات",
    "arrearsLabel": "بقایا جات کا لیبل",
    "arrived": "پہنچ گیا",
    "assign": "تفویض کریں۔",
    "assignTrip": "سفر تفویض کریں۔",
    "assignMultipleTrips": "متعدد سفر تفویض کریں۔",
    "assignVehicle": "گاڑی تفویض کریں۔",
    "assignedTrips": "تفویض شدہ سفر",
    "assist": "مدد کرنا",
    "assistShiftAlign": "اسسٹ شفٹ الائن",
    "assistShiftAlignIs": "اسسٹ شفٹ الائن کی ضرورت ہے۔",
    "assistShiftDayWise": "اسسٹ شفٹ (دن کے حساب سے)",
    "assistShiftEnd": "اسسٹ شفٹ اینڈ",
    "assistShiftEndIs": "اسسٹ شفٹ اینڈ کی ضرورت ہے۔",
    "assistShiftStart": "اسسٹ شفٹ اسٹارٹ",
    "assistShiftStartIs": "اسسٹ شفٹ اسٹارٹ درکار ہے۔",
    "assistsLabel": "مددگار",
    "associateImage": "ایسوسی ایٹ امیج",
    "atLeastOneAssist": "کم از کم ایک امدادی شفٹ درکار ہے۔",
    "atleastOneDayShift": "کم از کم ایک دن کی شفٹ کی ضرورت ہے۔",
    "atleastOneDriverIs": "کم از کم ایک ڈرائیور کی ضرورت ہے۔",
    "attachPdfButton": "پی ڈی ایف منسلک کریں",
    "attchedPdf": "منسلک پی ڈی ایف",
    "authNumberLabel": "منظوری کا نمبر",
    "authorizationNumberIsRequire": "اجازت نمبر درکار ہے۔",
    "authorizer": "اختیار دینے والا",
    "autoAssignWillCall": "آٹو اسائنٹ کال کریں گے۔",
    "autoGenerate": "آٹو جنریٹ",
    "autoRefresh": "آٹو ریفریش",
    "autoTimeStamp": "آٹو ٹائم اسٹیمپ",
    "autoTimestamp": "آٹو ٹائم اسٹیمپ",
    "autoZoom": "آٹو زوم",
    "available": "دستیاب",
    "avatar": "اوتار",
    "backToLogin": "لاگ ان پر واپس جائیں۔",
    "background": "پس منظر",
    "badPhonenumber": "خراب فون نمبر",
    "banked": "بینکڈ",
    "baseFare": "بیس کرایہ",
    "baseFareCode": "بیس کرایہ کا کوڈ",
    "baseFareCodeIs": "بیس کرایہ کوڈ درکار ہے۔",
    "baseFareFor": "کے لیے بیس کرایہ",
    "baseFareForIs": "کے لیے بیس کرایہ درکار ہے۔",
    "baseFareIsRequired": "بیس کرایہ درکار ہے۔",
    "batch": "بیچ",
    "bedBugProtocol": "بیڈ بگ پروٹوکول",
    "bedLengthIsRequired": "بستر کی لمبائی درکار ہے۔",
    "beginAt": "شروع کریں:",
    "billTo": "بل کو *",
    "billerNote": "بلر نوٹ",
    "billerNotes": "بلر نوٹس",
    "billing": "بلنگ",
    "bloodbornePathogenTrainingEx": "خون سے پیدا ہونے والے پیتھوجین ٹریننگ (EXP)",
    "bloodbornePathogens": "خون سے پیدا ہونے والے پیتھوجینز",
    "bodyType": "جسم کی قسم",
    "bodyTypeIsRequired": "جسم کی قسم درکار ہے۔",
    "both": "دونوں",
    "break": "توڑنا",
    "breakCushion": "کشن توڑنا:",
    "breakFinished": "بریک (ختم)",
    "breakScheduled": "بریک (شیڈول)",
    "breaks": "بریکس",
    "broker-img": "بروکر-آئی ایم جی",
    "brokerConfiguration": "بروکر کنفیگریشن",
    "brokerId": "بروکر ID",
    "brokerIsRequired": "بروکر کی ضرورت ہے۔",
    "bsr": "بی ایس آر",
    "bsr2": "BSR:",
    "bulkConfirmation": "بلک تصدیق",
    "businessNumber": "بزنس نمبر",
    "businessNumberIsRequired": "کاروباری نمبر درکار ہے۔",
    "businessReport": "بزنس رپورٹ",
    "businessReports": "بزنس رپورٹس",
    "busy": "مصروف",
    "bySavingTheInformation": "اس فارم میں معلومات کو محفوظ کر کے، آپ تنظیم کے ایک مجاز نمائندے کے طور پر اس بات کی تصدیق کرتے ہیں کہ معلومات اس کے ذریعے مکمل ہونے والی نقل و حمل کی درست عکاسی کرتی ہے۔ آپ اس کے ذریعے اس بات کی تصدیق کرتے ہیں کہ یہ معلومات آپ کے بہترین علم کے مطابق درست، درست اور مکمل ہے اور آپ سمجھتے ہیں کہ مادی حقیقت کو کسی بھی قسم کی جعلسازی، کوتاہی یا چھپانا آپ کو اور/یا تنظیم کو معاہدہ، انتظامی، شہری یا مجرمانہ ذمہ داری کا نشانہ بنا سکتا ہے۔ آپ یہ بھی سمجھتے ہیں کہ ان ٹرانسپورٹ کے تمام دستاویزات کو متعلقہ بیمہ بروکرز اور ان کے ملحقہ اداروں کی ریکارڈ مینٹیننس پالیسیوں کے مطابق برقرار رکھا جانا ہے۔",
    "caTimesheet": "CA ٹائم شیٹ",
    "calculateButton": "حساب کریں",
    "calculateLocalMiles": "مقامی میلوں کا حساب لگائیں۔",
    "call": "کال کریں۔",
    "callMemberToVerify": "منسوخی کی تصدیق کے لیے ممبر کو کال کریں۔",
    "cancel": "منسوخ کریں۔",
    "cancelCharges": "چارجز منسوخ کریں۔",
    "cancelChargesIsRequired": "چارجز منسوخ کرنے کی ضرورت ہے۔",
    "cancelReason": "وجہ منسوخ کریں۔",
    "cancelReasons": "وجوہات منسوخ کریں۔",
    "cancelReasonsIsRequired": "منسوخی کی وجوہات درکار ہیں۔",
    "cancelTrip": "سفر منسوخ کریں",
    "canceled": "منسوخ",
    "cancellationNotes": "منسوخی کے نوٹس",
    "cancelled": "منسوخ",
    "cancelledAt": "منسوخ ہونے پر:",
    "cancelledFee": "منسوخ شدہ فیس *",
    "cancelledTripsSection": "منسوخ سفروں کا سیکشن",
    "capacities": "صلاحیتیں",
    "capacity": "صلاحیت",
    "capacityIsRequired": "صلاحیت درکار ہے۔",
    "careGiverInformation": "نگہداشت دینے والے کی معلومات",
    "caregiverDetailsAreRequired": "دیکھ بھال کرنے والے کی تفصیلات درکار ہیں۔",
    "centeneAttestationIss": "سینٹین اٹیسٹیشن (ISS)",
    "certificateOfCompletionOnlok": "تکمیل کا سرٹیفکیٹ (ONLOK)",
    "certificationIsRequired": "سرٹیفیکیشن درکار ہے۔",
    "certifiedMechanicVerificatio": "مصدقہ مکینک تصدیق",
    "cf": "CF:",
    "change": "تبدیلی",
    "changePassword": "Change Password",
    "checkin": "چیک ان",
    "checklist": "چیک لسٹ",
    "checklistIsRequired": "چیک لسٹ درکار ہے۔",
    "checklistNameIsRequired": "چیک لسٹ کا نام درکار ہے۔",
    "checkout": "چیک آؤٹ",
    "chineseLanguageLabel": "چینی",
    "city": "شہر",
    "cityIsRequired": "شہر کی ضرورت ہے۔",
    "citystate": "شہر/ریاست",
    "claim": "دعویٰ",
    "claim2": "+ دعویٰ",
    "claimIsRequired": "دعویٰ درکار ہے۔",
    "claims": "دعوے",
    "clear": "صاف",
    "clearVehicle": "صاف گاڑی",
    "clientIdLabel": "کلائنٹ آئی ڈی / ممبر آئی ڈی / MA# / AHCCCS#",
    "clientIdRequired": "کلائنٹ آئی ڈی / ممبر آئی ڈی / MA# / AHCCCS# مطلوب ہے",
    "clone": "کلون",
    "close": "بند",
    "closePanel": "پینل بند کریں۔",
    "closeSidebar": "سائڈبار بند کریں۔",
    "closer": "قریب",
    "cms1500": "CMS 1500",
    "code": "کوڈ",
    "codeIsRequired": "کوڈ درکار ہے۔",
    "color": "رنگ",
    "colorIsRequired": "رنگ درکار ہے۔",
    "comment": "تبصرہ",
    "commentIsRequired": "تبصرہ درکار ہے۔",
    "comments": "تبصرے",
    "companiesStats": "کمپنیوں کے اعدادوشمار",
    "company-img": "company-img",
    "companyAlias": "کمپنی عرف *",
    "companyBillingName": "کمپنی بلنگ کا نام",
    "companyFaxNumber": "کمپنی کا فیکس نمبر",
    "companyImage": "کمپنی کی تصویر",
    "companyImageIsRequired": "کمپنی کی تصویر درکار ہے۔",
    "companyInTake": "کمپنی ان ٹیک (%)",
    "companyInTakeIs": "کمپنی ان ٹیک کی ضرورت ہے۔",
    "companyMobileNumber": "کمپنی کا موبائل نمبر",
    "companyMobileNumberIs": "کمپنی کا موبائل نمبر درکار ہے۔",
    "companyName": "کمپنی کا نام",
    "companyNameIsRequired": "کمپنی کا نام درکار ہے۔",
    "companyNotes": "کمپنی کے نوٹس",
    "companyPhoto": "کمپنی کی تصویر",
    "competency": "قابلیت",
    "competencyIsRequired": "اہلیت درکار ہے۔",
    "completed": "مکمل",
    "completedFee": "مکمل فیس*",
    "completedTimeIsRequired": "مکمل وقت درکار ہے۔",
    "compliancePlanTrainingFraud": "تعمیل پلان کی تربیت (فراڈ، فضلہ، اور غلط استعمال) (ضابطہ اخلاق)",
    "configurations": "کنفیگریشنز",
    "confirm": "تصدیق کریں۔",
    "confirmNewPassword": "نئے پاس ورڈ کی تصدیق کریں۔",
    "confirmPassword": "پاس ورڈ کی تصدیق کریں۔",
    "confirmPasswordDidtMatch": "تصدیق کریں کہ پاس ورڈ مماثل نہیں ہے۔",
    "confirmPasswordIsRequired": "تصدیق کریں پاس ورڈ درکار ہے۔",
    "confirmationReport": "تصدیقی رپورٹ",
    "confirmationText": "تصدیقی متن",
    "confirmedLabel": "تصدیق شدہ",
    "contactNumber": "رابطہ نمبر",
    "contactNumberIsRequired": "رابطہ نمبر درکار ہے۔",
    "contractSent": "معاہدہ بھیجا گیا۔",
    "corporate": "کارپوریٹ",
    "corporateOdometerRequired": "کارپوریٹ اوڈومیٹر درکار ہے۔",
    "corporatePrivatePay": "کارپوریٹ / پرائیویٹ پے",
    "costCenter": "لاگت کا مرکز",
    "costCenterIsRequired": "لاگت کا مرکز درکار ہے۔",
    "coverImage": "کور امیج",
    "covid": "Covid",
    "covid-19Vaccine": "Covid-19 ویکسین",
    "covid-19VaccineDeclined": "COVID-19 ویکسین مسترد کر دی گئی۔",
    "cprFirstAidCertification": "CPR / فرسٹ ایڈ سرٹیفیکیشن شروع ہونے کی تاریخ (EXP)",
    "cprFirstAidCertification2": "CPR / فرسٹ ایڈ سرٹیفیکیشن کی میعاد ختم ہونے کی تاریخ (EXP)",
    "createBucket": "بالٹی بنائیں",
    "createButton": "تخلیق کریں",
    "createSchedule": "شیڈول بنائیں",
    "createTrip": "ٹرپ بنائیں",
    "createTripsManually": "دستی طور پر سفر بنائیں",
    "created": "بنایا",
    "createdTimeIsRequired": "تخلیق کا وقت درکار ہے۔",
    "credentialInformation": "اسناد کی معلومات",
    "credentialing": "تصدیق نامہ",
    "credentials": "اسناد",
    "criminalBackgroundCheck": "مجرمانہ پس منظر کی جانچ",
    "criminalRecordAlcoholOr": "مجرمانہ ریکارڈ (شراب یا منشیات کا استعمال)",
    "ctc": "سی ٹی سی",
    "ctcBot": "سی ٹی سی بی او ٹی",
    "ctcInvoice": "CTC انوائس",
    "ctcMarketplace": "سی ٹی سی مارکیٹ پلیس",
    "ctcTrips": "CTC سفر",
    "currentMeter": "کرنٹ میٹر",
    "currentMileageIsRequired": "موجودہ مائلیج درکار ہے۔",
    "currentPassword": "موجودہ پاس ورڈ",
    "currentPasswordIsRequired": "موجودہ پاس ورڈ درکار ہے۔",
    "custom": "حسب ضرورت",
    "daily": "روزانہ",
    "dashboard": "ڈیش بورڈ",
    "date": "تاریخ",
    "dateFormat": "تاریخ کی شکل",
    "dateFormatIsRequired": "تاریخ کی شکل درکار ہے۔",
    "dateIsRequired": "تاریخ درکار ہے۔",
    "dateOfInspection": "معائنہ کی تاریخ",
    "dateOfInspectionIs": "معائنہ کی تاریخ درکار ہے۔",
    "dateOfService": "سروس کی تاریخ",
    "dateRange": "تاریخ کی حد*",
    "dayRequired": "دن مطلوب ہے",
    "days": "دن",
    "days2": "دن",
    "daysIsRequired": "دن درکار ہیں۔",
    "ddmmyyyy": "DD/MM/YYYY",
    "deadMiles": "ڈیڈ میلز",
    "deadMilesRateIs": "ڈیڈ میل ریٹ درکار ہے۔",
    "deadheadTimeToPickup": "ڈیڈ ہیڈ وقت (پک اپ تک)",
    "decline": "رد کرنا",
    "defensiveDrivingCourse": "دفاعی ڈرائیونگ کورس",
    "delete": "حذف کریں۔",
    "deleteAll": "سبھی کو حذف کریں۔",
    "demo": "ڈیمو",
    "description": "تفصیل",
    "descriptionIsRequired": "تفصیل درکار ہے۔",
    "detail": "تفصیل",
    "details": "تفصیلات",
    "diagnosismedicalCondition": "تشخیص/طبی حالت",
    "diagnosismedicalConditionIsR": "تشخیص/طبی حالت درکار ہے۔",
    "dimensions": "طول و عرض",
    "discount": "رعایت",
    "discountLabel": "ڈسکاؤنٹ لیبل",
    "dispatchMonthDay": "ڈسپیچ مہینے کا دن *",
    "dispatcher": "ڈسپیچر",
    "dispatcherNotesLabel": "ڈسپیچر کے نوٹ",
    "display": "ڈسپلے",
    "displayMode": "ڈسپلے موڈ",
    "displayNameLabel": "ظاہر ہونے والا نام",
    "displayNameRequired": "ظاہر ہونے والا نام مطلوب ہے",
    "displaySection": "ڈسپلے سیکشن",
    "do": "ڈراپ آف",
    "doModifier": "ڈی او موڈیفائر",
    "doModifierIsRequired": "ڈی او موڈیفائر کی ضرورت ہے۔",
    "doa": "DOA",
    "dobLabel": "تاریخ پیدائش",
    "dobRequired": "تاریخ پیدائش مطلوب ہے",
    "done": "ہو گیا",
    "dos": "DOS:",
    "dot": "DOT",
    "dotPhysicalExamAnnual": "DOT جسمانی امتحان (سالانہ یا درخواست پر)",
    "downBaseAddress": "نیچے کی بنیاد کا پتہ",
    "download": "ڈاؤن لوڈ کریں۔",
    "downloadCsv": "CSV ڈاؤن لوڈ کریں۔",
    "downloadPdf": "پی ڈی ایف ڈاؤن لوڈ کریں۔",
    "downloadPdfReport": "پی ڈی ایف رپورٹ ڈاؤن لوڈ کریں۔",
    "downloadReport": "رپورٹ ڈاؤن لوڈ کریں۔",
    "drawRoute": "راستہ بنائیں",
    "driveDistance": "ڈرائیو فاصلہ",
    "driver": "ڈرائیور",
    "driver-score-chartsWorks": "ڈرائیور سکور چارٹ کام کرتا ہے!",
    "driver2": "(ڈرائیور)",
    "driverAddress": "ڈرائیور کا پتہ",
    "driverAddressIsRequired": "ڈرائیور کا پتہ درکار ہے۔",
    "driverAlerts": "ڈرائیور الرٹس",
    "driverBreak": "ڈرائیور کی بریک",
    "driverBreakdown": "ڈرائیور کی خرابی۔",
    "driverImage": "ڈرائیور کی تصویر",
    "driverInTake": "ڈرائیور ان ٹیک (%)",
    "driverInTakeIs": "ڈرائیور ان ٹیک کی ضرورت ہے۔",
    "driverInformation": "ڈرائیور کی معلومات",
    "driverIsGettingLate": "ڈرائیور کو دیر ہو رہی ہے۔",
    "driverIsIdle": "ڈرائیور فارغ (کوئی سفر نہیں)",
    "driverIsLate": "ڈرائیور دیر سے ہے",
    "driverIsOverloaded": "ڈرائیور اوورلوڈ (>12 سفر)",
    "driverLoad": "ڈرائیور لوڈ",
    "driverName": "ڈرائیور کا نام",
    "driverNotesLabel": "ڈرائیور کے نوٹ",
    "driverOdometer": "ڈرائیور اوڈومیٹر",
    "driverProfile": "ڈرائیور پروفائل",
    "driverRequired": "ڈرائیور مطلوب ہے",
    "driverRoadTrainingEvidence": "ڈرائیور روڈ ٹریننگ (ثبوت)",
    "driverSched": "ڈرائیور شیڈول",
    "driverShift": "ڈرائیور شفٹ",
    "driverShiftDayWise": "ڈرائیور شفٹ (دن کے حساب سے)",
    "driverVerificationAlcohol": "ڈرائیور کی تصدیق (شراب)",
    "driverVerificationDrug": "ڈرائیور کی تصدیق (منشیات)",
    "driverdisplayname": "ڈرائیور ڈسپلے نام",
    "driversDrugTest": "ڈرائیور کا ڈرگ ٹیسٹ",
    "drivingRecordMeetsRequiremen": "ڈرائیونگ ریکارڈ (ضرورت کو پورا کرتا ہے)",
    "drop": "گراؤ",
    "dropoffAddress": "ڈراپ آف ایڈریس",
    "dropoffAddressIsRequired": "ڈراپ آف ایڈریس درکار ہے۔",
    "dropoffEarly": "جلدی چھوڑنا:",
    "dropoffHeader": "ڈراپ آف",
    "dropoffLate": "ڈراپ آف دیر سے:",
    "dropoffLateReason": "ڈراپ آف تاخیر کی وجہ:",
    "dropoffLateReason2": "ڈراپ آف تاخیر کی وجہ",
    "dropoffWise": "ڈراپ آف وائز",
    "dryRun": "ڈرائی رن",
    "dryRunCode": "ڈرائی رن کوڈ",
    "dryRunCodeIs": "ڈرائی رن کوڈ درکار ہے۔",
    "dsr": "DSR:",
    "dt": "ڈی ٹی",
    "dt2": "ڈی ٹی:",
    "dueDay": "مقررہ دن *",
    "duplicate": "نقل",
    "durationIsRequired": "مدت درکار ہے۔",
    "dvCompetencyAssessmentIss": "DV اہلیت کی تشخیص (ISS)",
    "dvRequired": "DV درکار ہے۔",
    "earlyActionActualVsScheduled": "جلد ایکشن (اصل بمقابلہ شیڈول)",
    "earlyEta": "ابتدائی ETA",
    "editNotes": "نوٹس میں ترمیم کریں۔",
    "editProfile": "پروفائل میں ترمیم کریں۔",
    "editShift": "شفٹ میں ترمیم کریں۔",
    "editTripHeader": "تبدیل کریں",
    "elderAbuseTraining": "بزرگوں کے ساتھ بدسلوکی کی تربیت",
    "eligibility": "اہلیت",
    "eligibilityStatusIsRequired": "اہلیت کی حیثیت درکار ہے۔",
    "eligible": "اہل",
    "email": "ای میل:",
    "emailAddress": "ای میل ایڈریس",
    "emailAddressIsRequired": "ای میل ایڈریس درکار ہے۔",
    "emailConfiguration": "ای میل کنفیگریشن",
    "emailIsNotValid": "ای میل درست نہیں ہے۔",
    "emailLabel": "ای میل",
    "emailRequired": "ای میل مطلوب ہے",
    "emergencyAndEvacuationTraini": "ایمرجنسی اور انخلاء کی تربیت",
    "employeeId": "ملازم کی شناخت",
    "employeeIdIsRequired": "ملازم کی شناخت درکار ہے۔",
    "employerNameIsRequired": "آجر کا نام درکار ہے۔",
    "employmentType": "ملازمت کی قسم",
    "employmentTypeIsRequired": "ملازمت کی قسم درکار ہے۔",
    "emtDriver": "EMT ڈرائیور",
    "emtLicense": "EMT لائسنس",
    "emtLicenseImageIs": "EMT لائسنس کی تصویر درکار ہے۔",
    "endDateLabel": "آخری تاریخ",
    "endDateRequired": "آخری تاریخ مطلوب ہے",
    "endOfShift": "شفٹ کا اختتام",
    "endTime": "اختتامی وقت",
    "endTimeIsRequired": "اختتامی وقت درکار ہے۔",
    "ended": "(ختم)",
    "endedAt": "پر ختم ہوا:",
    "englishLanguageLabel": "English",
    "ensureThereAreNo": "⚠️ اس بات کو یقینی بنائیں کہ بڑی آنت کے ارد گرد کوئی جگہ نہیں ہے۔ تلاش کو متحرک کرنے کے لیے کم از کم 3 حروف درکار ہیں۔",
    "enterTitle": "عنوان درج کریں۔",
    "enterYourEmail": "اپنا ای میل درج کریں۔",
    "enterYourEmailAnd": "اپنا ای میل درج کریں اور ری سیٹ لنک وصول کرنے کے لیے رول منتخب کریں۔",
    "enterYourNewPassword": "نیچے اپنا نیا پاس ورڈ درج کریں۔",
    "equipmentsAreRequired": "آلات درکار ہیں۔",
    "esf": "ESF:",
    "estimatedFareLabel": "اندازہ کرایہ",
    "estimatedFares": "تخمینہ شدہ کرایہ",
    "estimatedPickupTimeLabel": "اندازہ پک اپ:",
    "every": "ہر",
    "exiting": "باہر نکلنا",
    "expandOnHover": "ہوور پر پھیلائیں۔",
    "expectedAppointmentTimeLabel": "توقع ملاقات کا وقت",
    "expectedAppointmentTimeMinError": "توقع ملاقات کا وقت پک اپ کے وقت سے پہلے نہیں ہو سکتا",
    "expectedAppointmentTimeRequired": "توقع ملاقات کا وقت مطلوب ہے",
    "expenses": "اخراجات",
    "expirationDate": "میعاد ختم ہونے کی تاریخ",
    "expirationDateIsRequired": "میعاد ختم ہونے کی تاریخ درکار ہے۔",
    "expired": "میعاد ختم",
    "expiredTrips": "میعاد ختم سفر",
    "expiredTripsRoutes": "میعاد ختم سفروں کے روٹس",
    "expiryDate": "میعاد ختم ہونے کی تاریخ",
    "expiryDateIsRequired": "میعاد ختم ہونے کی تاریخ درکار ہے۔",
    "exportCsv": "CSV برآمد کریں۔",
    "extensiondispatcherNumber": "ایکسٹینشن/ڈسپیچر نمبر",
    "extensiondispatcherNumberIsR": "ایکسٹینشن/ڈسپیچر نمبر درکار ہے۔",
    "exteriorInformation": "بیرونی معلومات",
    "fare": "کرایہ",
    "fareInformation": "کرایہ کی معلومات",
    "faxNumber": "فیکس نمبر",
    "feedback": "تاثرات",
    "feet": "(پاؤں)",
    "fetch": "لانا",
    "fetchEta": "ETA حاصل کریں۔",
    "fetchTime": "وقت بازیافت کریں۔",
    "file": "(فائل)",
    "fileIsRequired": "فائل کی ضرورت ہے",
    "fileName": "فائل کا نام",
    "filter": "فلٹر",
    "fingerPrintLiveScan": "فنگر پرنٹ لائیو اسکین",
    "finished": "ختم",
    "finishedAndCancelled": "ختم اور منسوخ",
    "finishedAt": "پر ختم:",
    "finishedCompleted": "ختم / مکمل",
    "finishedTimeIsRequired": "مکمل وقت درکار ہے۔",
    "finishedTrips": "ختم شدہ سفر",
    "firstName": "پہلا نام",
    "firstNameIsRequired": "پہلا نام درکار ہے۔",
    "firstNameMustBe": "پہلا نام کم از کم 3 حروف کا ہونا چاہیے۔",
    "fleet": "گاڑیوں کا بیڑا",
    "fleetInformation": "بیڑے کی معلومات",
    "fleetIsRequired": "بیڑے کی ضرورت ہے۔",
    "floorLabel": "منزل",
    "floorRequired": "منزل مطلوب ہے",
    "florida": "فلوریڈا",
    "flu": "فلو",
    "fluVaccine": "فلو ویکسین",
    "fluVaccineDeclined": "فلو ویکسین مسترد کر دی گئی۔",
    "focalPerson": "فوکل پرسن",
    "focalPersonInformation": "فوکل پرسن کی معلومات",
    "for": "کے لیے",
    "force": "زبردستی",
    "forcedAcceptTrips": "زبردستی قبول سفر",
    "forgotPassword": "پاس ورڈ بھول گئے۔",
    "forgotPassword2": "پاس ورڈ بھول گئے؟",
    "form837": "فارم 837",
    "form837V2": "فارم 837 v2",
    "freeQuota": "مفت کوٹہ",
    "from": "سے",
    "fromIsRequired": "سے درکار ہے۔",
    "fsIsRequired": "ایف ایس کی ضرورت ہے۔",
    "fuelType": "ایندھن کی قسم",
    "fuelTypeIsRequired": "ایندھن کی قسم درکار ہے۔",
    "fullTime": "فل ٹائم",
    "fundingSourceAndValidity": "فنڈنگ ​​کا ذریعہ اور درستگی کی حد درکار ہے۔",
    "fundingSourceLabel": "فنڈنگ کا ذریعہ",
    "noViolation": "کوئی خلاف ورزی نہیں",
    "fundingSourceRequired": "فنڈنگ کا ذریعہ مطلوب ہے",
    "fundingSources": "فنڈنگ ​​کے ذرائع",
    "fundingSourcesAreRequired": "فنڈنگ ​​کے ذرائع درکار ہیں۔",
    "garage": "گیراج",
    "garageAddress": "گیراج کا پتہ",
    "garageAddressIsRequired": "گیراج کا پتہ درکار ہے۔",
    "gasCardNumber": "گیس کارڈ نمبر",
    "gasCardNumberIs": "گیس کارڈ نمبر درکار ہے۔",
    "genderFemale": "عورت",
    "genderLabel": "جنس",
    "genderMale": "مرد",
    "genderOther": "دیگر",
    "genderRequired": "جنس مطلوب ہے",
    "general": "جنرل",
    "georgia": "جارجیا",
    "gisMiles": "GIS میل",
    "goBackHome": "گھر واپس جاؤ",
    "googleMiles": "گوگل میلز",
    "groundClearanceIsRequired": "گراؤنڈ کلیئرنس درکار ہے۔",
    "groupByName": "نام سے گروپ",
    "groupImageIsRequired": "گروپ امیج درکار ہے۔",
    "groupName": "گروپ کا نام",
    "groupNameIsRequired": "گروپ کا نام درکار ہے۔",
    "groups": "گروپس",
    "gurneyTraining": "گرنی ٹریننگ",
    "handsFreeTraining": "ہینڈز فری ٹریننگ",
    "haversineMiles": "ہیورسین میلز",
    "height": "اونچائی",
    "heightIsRequired": "اونچائی کی ضرورت ہے۔",
    "hepatitis": "ہیپاٹائٹس",
    "hhmm": "(HH:mm)",
    "hhmm2": "ہمم",
    "hhmm3": "HH:mm",
    "hideOneHourException": "ایک گھنٹے کی رعایت چھپائیں۔",
    "hideThirdPartyDrivers": "تھرڈ پارٹی ڈرائیورز کو چھپائیں۔",
    "hideUnassignedTrips": "غیر تفویض شدہ دورے چھپائیں۔",
    "hipaaPhiTrainingValid": "HIPAA / PHI ٹریننگ (ہمیشہ کے لیے درست)",
    "history": "تاریخ",
    "holidayName": "چھٹیوں کا نام",
    "holidayNameIsRequired": "چھٹی کا نام درکار ہے۔",
    "hoodInformation": "ہڈ کی معلومات",
    "hospitalized": "ہسپتال میں داخل",
    "host": "میزبان",
    "howToUseThe": "🔍 تلاش کا استعمال کیسے کریں۔",
    "iaal": "IAAL",
    "ifYouAlterThe": "اگر آپ کسی ٹرپ کی معلومات کو اس طرح تبدیل کرتے ہیں کہ وہ اصل سفر کی تفصیلات سے میل نہیں کھاتی ہے تو آپ غلط بیان درج کر رہے ہیں اور جرم کر رہے ہیں۔ جو بھی جھوٹا بیان داخل کرے گا اس کے خلاف قانون کے مطابق کارروائی کی جائے گی۔",
    "image": "تصویر",
    "imageIsRequired": "تصویر درکار ہے۔",
    "img-corporate": "img-corporate",
    "importFile": "فائل درآمد کریں۔",
    "importingTripsFromBrokers": "بروکرز سے سفر درآمد کریں",
    "inActiveReason": "فعال وجہ میں",
    "inActiveReasonIs": "فعال وجہ کی ضرورت ہے۔",
    "inMinutes": "(منٹ میں)",
    "inProgress": "جاری ہے۔",
    "inProgressTrips": "جاری سفر",
    "inProgressRoutes": "جاری روٹس",
    "inReview": "جائزہ میں",
    "inVehicle": "گاڑی میں",
    "inactive": "غیر فعال",
    "incentive": "ترغیب",
    "incentiveIsRequired": "ترغیب درکار ہے۔",
    "indiana": "انڈیانا",
    "ineligible": "نااہل",
    "info": "معلومات",
    "informDriver": "ڈرائیور کو اطلاع دیں۔",
    "information": "معلومات",
    "inspectionPassOrFail": "معائنہ پاس یا فیل درکار ہے۔",
    "interiorInformation": "داخلہ معلومات",
    "invalidEmailFormat": "غلط ای میل فارمیٹ",
    "invalidTrip": "غلط سفر",
    "invoice": "رسید",
    "invoices": "انوائسز",
    "ipaLabel": "رقم IPA / FECA",
    "ipaRequired": "رقم IPA / FECA مطلوب ہے",
    "ipcr": "آئی پی سی آر",
    "isAcknowledgementOnFile": "کیا اعتراف فائل پر ہے؟",
    "isCertificateOnFile": "کیا سرٹیفکیٹ فائل پر ہے؟",
    "isWave": "لہر ہے۔",
    "issueDate": "جاری ہونے کی تاریخ",
    "issueDateIsRequired": "جاری کرنے کی تاریخ درکار ہے۔",
    "itineries": "سفر نامہ",
    "kpisdriverdisplayname": "kpis.driver.displayName",
    "language": "زبان",
    "lastInspectionDateIs": "آخری معائنہ کی تاریخ درکار ہے۔",
    "lastName": "آخری نام",
    "lastNameIsRequired": "آخری نام درکار ہے۔",
    "lastNameMustBe": "آخری نام کم از کم 3 حروف کا ہونا چاہیے۔",
    "lateCushion": "لیٹ کشن",
    "lateCushionIsRequired": "لیٹ کشن درکار ہے۔",
    "lateEta": "دیر سے ای ٹی اے",
    "lbs": "(lbs)",
    "legCancellationAlert": "ٹانگوں کی منسوخی کا الرٹ",
    "legLabel": "مرحلہ-",
    "legalInformation": "قانونی معلومات",
    "legalName": "قانونی نام",
    "legalNameIsRequired": "قانونی نام درکار ہے۔",
    "legalNameMustBe": "قانونی نام کم از کم 3 حروف کا ہونا چاہیے۔",
    "lengthIsRequired": "لمبائی درکار ہے۔",
    "lengthMustBe3": "لمبائی 3 ہونی چاہیے۔",
    "levelOfServiceImage": "سروس کی تصویر کی سطح",
    "levelOfServiceLabel": "سروس کا لیول",
    "levelOfServiceRequired": "سروس کا لیول مطلوب ہے",
    "levelofservice-image": "levelOfService-image",
    "licenseInformation": "لائسنس کی معلومات",
    "licenseNumber": "لائسنس نمبر",
    "licenseNumberIsRequired": "لائسنس نمبر درکار ہے۔",
    "licensePlate": "لائسنس پلیٹ",
    "licensePlateInformation": "لائسنس پلیٹ کی معلومات",
    "licensePlateIsRequired": "لائسنس پلیٹ درکار ہے۔",
    "lightsInformation": "لائٹس کی معلومات",
    "limitation": "حد بندی",
    "limitations": "حدود",
    "line": "لائن",
    "list": "فہرست",
    "listView": "فہرست دیکھیں",
    "livescanDojFbi": "LIVESCAN (DOJ +FBI)",
    "livescanDojOnly": "LIVESCAN (صرف DOJ)",
    "load": "لوڈ",
    "loadTimeIsRequired": "لوڈ ٹائم درکار ہے۔",
    "loadedMilesRateIs": "لوڈڈ میل ریٹ درکار ہے۔",
    "loadedTime": "بھری ہوئی وقت",
    "loadedTimeToDropoff": "لوڈڈ وقت (ڈراپ آف تک)",
    "loginInformation": "لاگ ان معلومات",
    "logisticareTemplate": "LogistiCare ٹیمپلیٹ",
    "logo": "لوگو",
    "logout": "لاگ آؤٹ",
    "logs": "نوشتہ جات",
    "los": "LOS:",
    "losAndSpaceType": "لاس اور اسپیس کی قسم درکار ہے۔",
    "lt": "ایل ٹی",
    "lt2": "ایل ٹی:",
    "lunch": "لنچ",
    "maintenanceInformation": "بحالی کی معلومات",
    "maintenances": "دیکھ بھال",
    "makeItLive": "اسے لائیو بنائیں",
    "makeModel": "بنائیں اور ماڈل",
    "makeModelIsRequired": "بنائیں اور ماڈل درکار ہے۔",
    "mandatoryForCms1500": "(CMS 1500 فارم کے لیے لازمی)",
    "mandatoryForMedicaidAnd": "(Medicaid اور CMS 1500 فارمز کے لیے لازمی)",
    "mandatoryForMedicaidAuth": "(Medicaid Auth Form کے لیے لازمی)",
    "manifest": "مینیسٹ",
    "manifestLegend": "مینی فیسٹ لیجنڈ",
    "manual": "رہنما کتابچہ",
    "manualGenerate": "دستی پیدا کریں۔",
    "manualTrip": "دستی سفر",
    "mapperIsRequired": "میپر درکار ہے۔",
    "markComplete": "مکمل نشان زد کریں۔",
    "markMemberReady": "ممبر کو تیار نشان زد کریں",
    "markedReady": "تیار نشان زد",
    "markedReadyRoutes": "تیار نشان زد روٹس",
    "markedReadyTrips": "تیار نشان زد سفر",
    "marketplace": "بازار",
    "maxDistance": "زیادہ سے زیادہ فاصلہ:",
    "maxOnboardTime": "زیادہ سے زیادہ آن بورڈ وقت:",
    "maxTrips": "زیادہ سے زیادہ دورے:",
    "meal": "کھانا",
    "mealBreak": "کھانے کا وقفہ",
    "mechanicverificationsignatur": "mechanicVerification.signature",
    "medex": "میڈیکس",
    "medical": "میڈیکل",
    "medicalIdIsRequired": "میڈیکل آئی ڈی درکار ہے۔",
    "medicalLogo": "میڈیکل لوگو",
    "medicalTrip": "طبی سفر",
    "member-image": "رکن کی تصویر",
    "memberLabel": "رکن",
    "memberLoading": "ممبر لوڈ ہو رہا ہے۔",
    "memberName": "ممبر کا نام",
    "memberNotVisible": "ممبر نظر نہیں آتا",
    "memberOnboard": "ممبر آن بورڈ",
    "memberOnboardAt": "ممبر آن بورڈ پر:",
    "memberRequired": "رکن مطلوب ہے",
    "memberRoleIsRequired": "ممبر رول درکار ہے۔",
    "memberStatus": "ممبر کی حیثیت",
    "memberType": "ممبر کی قسم",
    "memberTypeIsRequired": "ممبر کی قسم درکار ہے۔",
    "memberdisplayname": "member.displayName",
    "membersPhoneNumber": "ممبر کا فون نمبر",
    "merge": "ضم کرنا",
    "messageAlerts": "میسج الرٹس",
    "messages": "پیغامات",
    "methadone": "میتھاڈون",
    "method": "طریقہ",
    "methodIsRequired": "طریقہ درکار ہے۔",
    "mfa": "(MFA)",
    "mfb": "MFB",
    "mi": "mi",
    "mid": "وسط",
    "middleName": "درمیانی نام",
    "middleNameIsRequired": "درمیانی نام درکار ہے۔",
    "mile": "میل",
    "miles": "میل",
    "milesForBucksDriver": "بکس ڈرائیور کے لیے میل",
    "milesForBucksPanel": "بکس پینل کے لیے میل",
    "milesLabel": "میل",
    "milesRequired": "میل مطلوب ہیں",
    "minimum3CharactersRequired": "کم از کم 3 حروف درکار ہیں۔",
    "minimum5CharactersRequired": "کم از کم 5 حروف درکار ہیں۔",
    "mins": "منٹ",
    "minutes": "منٹ",
    "minutesIsRequired": "منٹ درکار ہیں۔",
    "mm": "(ملی میٹر)",
    "mmddyyyy": "MM/DD/YYYY",
    "mobileNumberLabel": "موبائل نمبر",
    "mobileNumberRequired": "موبائل نمبر مطلوب ہے",
    "model": "ماڈل",
    "modelIsRequired": "ماڈل درکار ہے۔",
    "modifierLabel": "ترمیم کنندہ",
    "modifierRequired": "ترمیم کنندہ مطلوب ہے",
    "moicu": "ایم او آئی سی یو",
    "moreFeaturesComingSoon": "📝 مزید خصوصیات جلد آرہی ہیں۔",
    "moreLabel": "مزید...",
    "na": "N/A",
    "name": "نام",
    "nameIsRequired": "نام درکار ہے۔",
    "nemt": "NEMT",
    "nemtStatistics": "NEMT شماریات",
    "newExpense": "نیا خرچہ",
    "newInspection": "نیا معائنہ",
    "newPassword": "نیا پاس ورڈ",
    "newPasswordIsRequired": "نیا پاس ورڈ درکار ہے۔",
    "no": "نہیں",
    "noAgentTripsTo": "دکھانے کے لیے کوئی ایجنٹ کا سفر نہیں ہے۔",
    "noAnswer": "کوئی جواب نہیں۔",
    "noCompanyDetailsTo": "دکھانے کے لیے کمپنی کی کوئی تفصیلات نہیں ہیں۔",
    "noCtcTripTo": "دکھانے کے لیے کوئی CTC ٹرپ نہیں۔",
    "noDataToShow": "دکھانے کے لیے کوئی ڈیٹا نہیں۔",
    "noDetailsToShow": "دکھانے کے لیے کوئی تفصیلات نہیں۔",
    "noDirtRoadTrips": "دکھانے کے لیے کوئی گندگی والی سڑک نہیں ہے۔",
    "noDriverDetailsTo": "دکھانے کے لیے ڈرائیور کی کوئی تفصیلات نہیں ہیں۔",
    "noEarning": "کوئی کمائی نہیں۔",
    "noEarningsToShow": "دکھانے کے لیے کوئی کمائی نہیں۔",
    "noMessageToShow": "دکھانے کے لیے کوئی پیغام نہیں۔",
    "noNotificationsToShow": "دکھانے کے لیے کوئی اطلاعات نہیں ہیں۔",
    "noOfEscortsLabel": "مرافقین کی تعداد",
    "noOfEscortsRequired": "مرافقین کی تعداد مطلوب ہے",
    "noOfRoutes": "راستوں کی تعداد",
    "noOfRoutesAre": "راستوں کی تعداد درکار ہے۔",
    "noOfSeats": "نشستوں کی تعداد",
    "noOfSeatsAre": "نشستوں کی تعداد درکار ہے۔",
    "noParsedFileFound": "کوئی تجزیہ شدہ فائل نہیں ملی",
    "noRecords": "کوئی ریکارڈ نہیں۔",
    "noShowCharges": "کوئی شو چارجز نہیں۔",
    "noShowChargesIs": "شو چارجز کی ضرورت نہیں ہے۔",
    "noStatisticsToShow": "دکھانے کے لیے کوئی اعدادوشمار نہیں۔",
    "noTripLogsTo": "دکھانے کے لیے کوئی ٹرپ لاگز نہیں۔",
    "noTripsAssign": "کوئی ٹرپس تفویض نہیں۔",
    "noTripsToShow": "دکھانے کے لیے کوئی ٹرپس نہیں۔",
    "noUnassignedTrips": "کوئی غیر تفویض کردہ دورے نہیں ہیں۔",
    "non-transportVehicle": "نان ٹرانسپورٹ وہیکل",
    "none": "کوئی نہیں۔",
    "notAvailable": "دستیاب نہیں",
    "notEligible": "اہل نہیں",
    "note": "نوٹ",
    "notes": "نوٹس",
    "notesAreRequired": "نوٹس درکار ہیں۔",
    "notificationMethod": "اطلاع کا طریقہ",
    "notifications": "اطلاعات",
    "odometer": "اوڈومیٹر",
    "odometerBegin": "اوڈومیٹر شروع",
    "odometerBeginIsRequired": "Odometer Begin کی ضرورت ہے۔",
    "odometerBeginReadingIs": "Odometer Begin Reading کی ضرورت ہے۔",
    "odometerEndIsRequired": "اوڈومیٹر کا اختتام درکار ہے۔",
    "odometerRequired": "اوڈومیٹر کی ضرورت ہے۔",
    "odometerStart": "اوڈومیٹر شروع",
    "odometerStartIsRequired": "اوڈومیٹر شروع کرنا ضروری ہے۔",
    "odometerStop": "اوڈومیٹر سٹاپ",
    "odometerStopIsRequired": "اوڈومیٹر سٹاپ درکار ہے۔",
    "of": "میں سے",
    "offeredAccepted": "پیش کردہ / قبول شدہ",
    "offeredTrips": "پیش کردہ سفر",
    "offline": "آف لائن",
    "oigScreening": "OIG اسکریننگ",
    "onScene": "منظر پر:",
    "onScene2": "آن سین",
    "onSceneReport": "آن سین رپورٹ",
    "onWay": "راستے میں",
    "onWayAt": "راستے میں:",
    "onboard": "جہاز پر",
    "oneHourException": "1 گھنٹے کا استثنا",
    "onq": "ONQ",
    "onscene": "آن سین",
    "onsceneTimeIsRequired": "موقع پر وقت درکار ہے۔",
    "onway": "جاری ہے۔",
    "open": "کھولیں۔",
    "openMainMenu": "مین مینو کھولیں۔",
    "openUserMenu": "یوزر مینو کھولیں۔",
    "opener": "اوپنر",
    "operations": "آپریشنز",
    "operationsManager": "آپریشنز مینیجر",
    "operationsManagerIsRequired": "آپریشنز مینیجر کی ضرورت ہے۔",
    "optIn": "OPT In",
    "orDragAndDrop": "یا گھسیٹیں اور چھوڑیں۔",
    "ordAct": "آرڈر/ایکٹ",
    "order": "آرڈر",
    "orderIsRequired": "آرڈر کی ضرورت ہے۔",
    "organizationId": "تنظیم کی شناخت",
    "organizationIdIsRequired": "تنظیم کی شناخت درکار ہے۔",
    "otherInformation": "دیگر معلومات",
    "otherLegsHeader": "دوسرے مراحل",
    "others": "دوسرے",
    "otp": "OTP",
    "outsideShift": "شفٹ سے باہر",
    "outstandingTrips": "زیر التواء سفر",
    "ownerDetails": "مالک کی تفصیلات",
    "pageNotFound": "صفحہ نہیں ملا",
    "paid": "ادا کیا",
    "panel": "پینل",
    "parseTrips": "دوروں کو پارس کریں۔",
    "partTime": "پارٹ ٹائم",
    "partner": "پارٹنر",
    "passenger": "مسافر",
    "passengerAssistanceAndCultur": "مسافروں کی مدد اور ثقافتی تربیت (EXP)",
    "passengerInformation": "مسافروں کی معلومات",
    "password": "پاس ورڈ",
    "passwordInformation": "پاس ورڈ کی معلومات",
    "passwordIsRequired": "پاس ورڈ درکار ہے۔",
    "passwordMustBeAtleast": "پاس ورڈ کم از کم 6 حروف کا ہونا چاہیے۔",
    "passwordMustBeAtleast2": "پاس ورڈ کم از کم 6 حروف کا ہونا چاہیے۔",
    "passwordMustBeMaximum": "پاس ورڈ زیادہ سے زیادہ 16 حروف کا ہونا چاہیے۔",
    "passwordMustBeMaximum2": "پاس ورڈ زیادہ سے زیادہ 16 حروف کا ہونا چاہیے۔",
    "patient": "مریض",
    "paymentConfirmed": "ادائیگی کی تصدیق ہوگئی",
    "paymentUnconfirmed": "ادائیگی غیر تصدیق شدہ",
    "payorLabel": "ادائیگی کرنے والا",
    "pending": "زیر التواء",
    "pendingFee": "زیر التواء فیس *",
    "perMile": "فی میل",
    "perMileCode": "فی میل کوڈ",
    "perMileCodeIs": "فی میل کوڈ درکار ہے۔",
    "perMileIsRequired": "فی میل درکار ہے۔",
    "perMinIsRequired": "فی منٹ درکار ہے۔",
    "perMinute": "فی منٹ",
    "period": "مدت",
    "permissions": "اجازتیں",
    "person": "شخص",
    "phoneNumberLabel": "فون نمبر",
    "phoneNumberRequired": "فون نمبر مطلوب ہے",
    "pickupAddress": "اٹھانے کا پتہ",
    "pickupAddressIsRequired": "پک اپ ایڈریس درکار ہے۔",
    "pickupEarly": "جلدی پک اپ:",
    "pickupHeader": "پک اپ",
    "pickupLate": "پک اپ لیٹ:",
    "pickupLateReason": "پک اپ لیٹ ہونے کی وجہ",
    "pickupLateReasons": "پک اپ میں تاخیر کی وجوہات:",
    "pickupTme": "پک اپ Tme",
    "pickupWise": "پک اپ وائز",
    "placeNameLabel": "گھر / سہولت کا نام",
    "placeNameRequired": "گھر / سہولت کا نام مطلوب ہے",
    "planner": "منصوبہ ساز",
    "platform": "پلیٹ فارم",
    "platformIsRequired": "پلیٹ فارم درکار ہے۔",
    "platformportal": "پلیٹ فارم/پورٹل",
    "platformportalIsRequired": "پلیٹ فارم/پورٹل درکار ہے۔",
    "pleaseChooseAnyAbove": "براہ کرم اوپر کی کوئی بھی وجہ منتخب کریں۔",
    "pleaseEnterDispatcherNotes": "براہ کرم ڈسپیچر کے نوٹس درج کریں۔",
    "pleaseEnterForDriver": "براہ کرم ڈرائیور کے نوٹس کے لیے درج کریں۔",
    "pleaseEnterTheClient": "براہ کرم کلائنٹ کا نام درج کریں۔",
    "pleaseEnterTheDate": "براہ کرم ڈرائیور کی موٹر گاڑی کے ریکارڈ کی جانچ کی تاریخ درج کریں۔",
    "pleaseEnterTheDescription": "براہ کرم تفصیل درج کریں۔",
    "pleaseEnterTheNote": "براہ کرم نوٹ درج کریں۔",
    "pleaseEnterTheNotes": "براہ کرم نوٹس درج کریں۔",
    "pleaseEnterThePrivate": "براہ کرم نجی نوٹ درج کریں۔",
    "pleaseEnterTheTime": "براہ کرم ٹائم زون درج کریں۔",
    "pleaseNoteByUsing": "براہ کرم نوٹ کریں، اس خصوصیت کو استعمال کرتے ہوئے آپ کو کسی ایسے دورے کو چھوڑ دینا چاہیے جو زمین پر نہیں کیے گئے ہیں تاکہ سسٹم پر کوئی معلومات من گھڑت نہ ہوں۔",
    "pleaseSelectAtLeast": "براہ کرم کم از کم ایک ڈرائیور منتخب کریں۔",
    "pleaseSelectCompanyTo": "ریکارڈ کو ظاہر کرنے کے لیے براہ کرم کمپنی کا انتخاب کریں۔",
    "pleaseSelectPrimaryMember": "براہ کرم پرائمری ممبر منتخب کریں۔",
    "pleaseSelectTimeIn": "براہ کرم وقت کا انتخاب کریں۔",
    "pleaseTakeNoticeFiling": "براہ کرم نوٹس لیں: جھوٹے بیانات درج کرنا جرم ہے",
    "pngJpgGifUp": "PNG، JPG، GIF 10MB تک",
    "policeClearance": "پولیس کلیئرنس",
    "port": "بندرگاہ",
    "portIsRequired": "پورٹ درکار ہے۔",
    "position": "پوزیشن",
    "positionIsRequired": "پوزیشن درکار ہے۔",
    "possibilityButton": "امکان",
    "primary": "پرائمری",
    "primaryDiagnoseLabel": "بنیادی تشخیص",
    "primaryDiagnoseRequired": "بنیادی تشخیص مطلوب ہے",
    "priority": "ترجیح",
    "priorityIsRequired": "ترجیح درکار ہے۔",
    "privateLabel": "(نجی)",
    "privateNote": "پرائیویٹ نوٹ",
    "proceed": "آگے بڑھیں۔",
    "proficiency": "مہارت",
    "proficiencyIsRequired": "مہارت کی ضرورت ہے۔",
    "profile": "پروفائل",
    "profileImage": "پروفائل امیج",
    "profileImageIsRequired": "پروفائل تصویر درکار ہے۔",
    "profileInformation": "پروفائل کی معلومات",
    "profileOverview": "پروفائل کا جائزہ",
    "profileimage": "profile_image",
    "protips": "پیشہ ورانہ تجاویز",
    "proposedReadyTime": "مجوزہ تیار وقت",
    "pu": "پک اپ",
    "puModifier": "PU موڈیفائر",
    "puModifierIsRequired": "PU موڈیفائر درکار ہے۔",
    "pua": "PUA",
    "publicLabel": "(عوامی)",
    "pull-Out": "کھینچنا - باہر کرنا",
    "pullEnd": "کھینچنا / ختم کرنا",
    "punjabiLanguageLabel": "پنجابی",
    "put": "PUT",
    "quantityLabel": "مقدار",
    "quantityRequired": "مقدار مطلوب ہے",
    "quarterdisplayname": "quarter.displayName",
    "quickFilter": "فوری فلٹر",
    "quickSearch": "فوری تلاش",
    "quickSearchGuide": "🔍 فوری تلاش گائیڈ",
    "radiusIsRequired": "رداس درکار ہے۔",
    "rates": "شرحیں",
    "rawReport": "خام رپورٹ",
    "re-assign": "دوبارہ تفویض کریں۔",
    "readyNotes": "تیار نوٹس",
    "reason": "وجہ",
    "reasonIsRequired": "وجہ مطلوب ہے۔",
    "recurringDays": "بار بار چلنے والے دن",
    "recurringStatusRequired": "تکرار کی حیثیت مطلوب ہے",
    "refS": "حوالہ #s",
    "reference": "حوالہ",
    "reg": "رجسٹر:",
    "regular": "باقاعدہ",
    "reject": "رد کرنا",
    "rejected": "مسترد",
    "rejectedTrips": "مسترد شدہ سفر",
    "relation": "رشتہ",
    "relationIsRequired": "رشتہ مطلوب ہے۔",
    "removeButton": "ختم کریں",
    "reply": "جواب دیں۔",
    "reports": "رپورٹس",
    "representativesignature": "نمائندہ دستخط",
    "requiredOdometers": "مطلوبہ اوڈومیٹر",
    "rescheduleTrip": "ٹرپ کو ری شیڈول کریں۔",
    "resendCode": "کوڈ دوبارہ بھیجیں؟",
    "reservationNo": "ریزرویشن نمبر:",
    "reset": "دوبارہ ترتیب دیں۔",
    "resetPassword": "پاس ورڈ ری سیٹ کریں۔",
    "responseNightCode": "رسپانس نائٹ کوڈ",
    "responseNightCodeIs": "رسپانس نائٹ کوڈ درکار ہے۔",
    "rest": "آرام کریں۔",
    "restBreak": "آرام کا وقفہ",
    "return": "واپسی",
    "revenue": "آمدنی",
    "reviewUrl": "URL کا جائزہ لیں۔",
    "rfLfRrLr": "(RF LF RR LR)",
    "rigNo": "رگ نمبر",
    "rigNoIsRequired": "رگ نمبر کی ضرورت ہے۔",
    "ripplingId": "Rippling Id",
    "ripplingIdIsRequired": "Rippling Id درکار ہے۔",
    "rode": "سواری ہوئی",
    "roleIsRequired": "کردار کی ضرورت ہے۔",
    "roleType": "کردار کی قسم",
    "roleTypeIsRequired": "کردار کی قسم درکار ہے۔",
    "roomLabel": "کمرہ",
    "roomRequired": "کمرہ مطلوب ہے",
    "routeDetails": "روٹ کی تفصیلات",
    "routeView": "روٹ ویو",
    "samScreening": "SAM اسکریننگ",
    "save": "محفوظ کریں۔",
    "saveForAll": "سب کے لیے محفوظ کریں۔",
    "saveTemplate": "سانچہ محفوظ کریں۔",
    "scheduleShells": "شیڈول شیل",
    "scheduleShellsIsRequired": "شیڈول شیل (زبانیں) کی ضرورت ہے۔",
    "scheduleTime": "شیڈول ٹائم",
    "scheduleTimeIsRequired": "شیڈول ٹائم درکار ہے۔",
    "scheduledTrips": "شیڈول شدہ سفر",
    "score": "سکور",
    "scoreDetails": "اسکور کی تفصیلات",
    "search": "تلاش کریں۔",
    "search2": "تلاش کریں...",
    "searchCompany": "تلاش کمپنی",
    "searchDriver": "ڈرائیور تلاش کریں۔",
    "searchGroup": "تلاش گروپ",
    "searchMessages": "پیغامات تلاش کریں۔",
    "searchVehicle": "گاڑی تلاش کریں۔",
    "seconds": "(سیکنڈ)",
    "secureComplianceTrainingAckn": "محفوظ تعمیل کی تربیت کا اعتراف",
    "secureType": "محفوظ قسم",
    "seeAll": "سب دیکھیں",
    "seenBy": "کی طرف سے دیکھا",
    "selectAddonItemPlaceholder": "-- آئٹم منتخب کریں --",
    "selectAll": "سبھی کو منتخب کریں۔",
    "selectAppointmentDirectionPlaceholder": "-- ملاقات کی سمت منتخب کریں --",
    "selectAppointmentTypePlaceholder": "-- ملاقات کی قسم منتخب کریں --",
    "selectAssistsPlaceholder": "-- مددگار منتخب کریں --",
    "selectBreak": "وقفے کو منتخب کریں۔",
    "selectCorporate": "کارپوریٹ منتخب کریں۔",
    "selectDate": "تاریخ منتخب کریں۔",
    "selectDateRange": "تاریخ کی حد منتخب کریں۔",
    "selectDos": "DOS کو منتخب کریں۔",
    "selectDriver": "ڈرائیور کو منتخب کریں۔",
    "selectDriverPlaceholder": "-- ڈرائیور منتخب کریں --",
    "selectFundingSource": "فنڈنگ ​​کا ذریعہ منتخب کریں۔",
    "selectFundingSourcePlaceholder": "-- فنڈنگ کا ذریعہ منتخب کریں --",
    "selectGenderPlaceholder": "-- جنس منتخب کریں --",
    "selectLevelOfService": "سروس کی سطح کو منتخب کریں۔",
    "selectLevelOfServicePlaceholder": "-- سروس کا لیول منتخب کریں --",
    "selectMember": "ممبر منتخب کریں۔",
    "selectMemberPlaceholder": "-- رکن منتخب کریں --",
    "selectModifierPlaceholder": "-- ترمیم کنندہ منتخب کریں --",
    "selectNoOfEscortsPlaceholder": "-- مرافقین کی تعداد منتخب کریں --",
    "selectPayorPlaceholder": "-- ادائیگی کرنے والا منتخب کریں --",
    "selectPrimaryDiagnosePlaceholder": "-- بنیادی تشخیص منتخب کریں --",
    "selectServiceArea": "سروس ایریا منتخب کریں۔",
    "selectServiceAreaPlaceholder": "-- سروس کا علاقہ منتخب کریں --",
    "selectSpaceType": "خلائی قسم منتخب کریں۔",
    "selectSpaceTypePlaceholder": "-- جگہ کی قسم منتخب کریں --",
    "selectStatus": "اسٹیٹس کو منتخب کریں۔",
    "selectTime": "وقت منتخب کریں۔",
    "selectTimezone": "ٹائم زون منتخب کریں۔",
    "selectType": "قسم منتخب کریں۔",
    "selectedDriverIsRequired": "منتخب ڈرائیور کی ضرورت ہے۔",
    "selectedServiceAreaIs": "منتخب سروس ایریا درکار ہے۔",
    "selectedTrip": "منتخب سفر",
    "send": "بھیجیں۔",
    "sendCode": "کوڈ بھیجیں۔",
    "sendEmail": "ای میل بھیجیں۔",
    "sendOnBreak": "بریک پر بھیجیں۔",
    "sentYouAnInvite": "آپ کو رابطہ قائم کرنے کا دعوت نامہ بھیجا ہے۔",
    "serviceAreaLabel": "سروس کا علاقہ",
    "serviceAreaRequired": "سروس کا علاقہ مطلوب ہے",
    "serviceAreas": "سروس ایریا",
    "serviceAreasIsRequired": "سروس ایریا درکار ہے۔",
    "serviceNameIsRequired": "سروس کا نام درکار ہے۔",
    "serviceRepresentative": "سروس کا نمائندہ",
    "services": "خدمات",
    "setBsr": "بی ایس آر سیٹ کریں۔",
    "setTags": "ٹیگز سیٹ کریں۔",
    "setiD": "سیٹی ڈی:",
    "settings": "ترتیبات",
    "sexOffenderBackgroundCheck": "جنسی مجرم کا پس منظر چیک کریں۔",
    "sexualHarassmentTraining": "جنسی طور پر ہراساں کرنے کی تربیت",
    "shift": "شفٹ:",
    "shift-End": "شفٹ - اینڈ",
    "shiftAlign": "شفٹ الائن",
    "shiftAlignIsRequired": "شفٹ الائن کی ضرورت ہے۔",
    "shiftDayWise": "شفٹ (دن کے حساب سے)",
    "shiftEnd": "شفٹ اینڈ",
    "shiftEndIsRequired": "شفٹ اینڈ کی ضرورت ہے۔",
    "shiftMarker": "شفٹ مارکر",
    "shiftOverride": "شفٹ اووررائیڈ",
    "shiftOverrideNotAvailable": "شفٹ اووررائیڈ (دستیاب نہیں)",
    "shiftStart": "شفٹ اسٹارٹ",
    "shiftStartIsRequired": "شفٹ اسٹارٹ درکار ہے۔",
    "shifts": "شفٹس",
    "showBreak": "بریک دکھائیں۔",
    "showGoogleMiles": "گوگل میل دکھائیں۔",
    "showRoute": "راستہ دکھائیں۔",
    "showUnassignedTrips": "غیر تفویض کردہ دورے دکھائیں۔",
    "signIn": "سائن ان کریں۔",
    "signInToYour": "اپنے اکاؤنٹ میں سائن ان کریں۔",
    "signature": "دستخط",
    "signatureIsRequired": "دستخط درکار ہیں۔",
    "single": "سنگل",
    "skipSignature": "دستخط چھوڑ دیں۔",
    "smokeFreeVehiclesDriver": "دھواں سے پاک گاڑیاں (ڈرائیور کی سمجھ)",
    "sms": "ایس ایم ایس",
    "sms/dashboard": "ایس ایم ایس ڈیش بورڈ",
    "smsRequired": "ایس ایم ایس درکار ہے۔",
    "sorryWeCouldntFind": "معذرت، ہمیں وہ صفحہ نہیں مل سکا جس کی آپ تلاش کر رہے ہیں۔",
    "sort": "چھانٹنا",
    "spaceTypeLabel": "جگہ کی قسم",
    "spaceTypeRequired": "جگہ کی قسم مطلوب ہے",
    "spaceTypefileIsRequired": "Space Type(File) is required",
    "spaceTypesIsRequired": "خلائی قسم (قسم) درکار ہے۔",
    "spacetypeImage": "اسپیس ٹائپ امیج",
    "spacetypeIsRequired": "اسپیس ٹائپ درکار ہے۔",
    "spacetypes": "اسپیس ٹائپ",
    "spanishLanguageLabel": "ہسپانوی",
    "specialFare": "خصوصی کرایہ",
    "specialRequests": "خصوصی درخواستیں۔",
    "squareImageIsRecommended": "* مربع تصویر کی سفارش کی جاتی ہے۔",
    "ssl": "ایس ایس ایل",
    "staff": "(اسٹاف)",
    "stagingTrips": "سٹیجنگ ٹرپس",
    "stairsSteps": "سیڑھیاں قدم / سیکنڈ",
    "stairsStepsIsRequired": "سیڑھیوں کا مرحلہ درکار ہے۔",
    "standingOrderHeader": "مستقل آرڈر",
    "startDate": "آغاز کی تاریخ",
    "startDateIsRequired": "آغاز کی تاریخ درکار ہے۔",
    "startTime": "آغاز کا وقت",
    "startTimeIsRequired": "آغاز کا وقت درکار ہے۔",
    "started": "شروع",
    "startedAt": "شروع ہوا:",
    "startedTimeIsRequired": "شروع ہونے کا وقت درکار ہے۔",
    "statReport": "اسٹیٹ رپورٹ",
    "stateCode": "ریاستی کوڈ",
    "stateCodeIsRequired": "ریاستی کوڈ درکار ہے۔",
    "stateIsRequired": "ریاست کی ضرورت ہے۔",
    "statistics": "شماریات",
    "statusActive": "فعال",
    "statusInactive": "غیر فعال",
    "statusIsRequired": "حیثیت درکار ہے۔",
    "statusLabel": "حیثیت",
    "statuses": "حالات",
    "statuss": "حیثیت",
    "stop": "رک جاؤ",
    "stopTimeIsRequired": "رکنے کا وقت درکار ہے۔",
    "storageInformation": "اسٹوریج کی معلومات",
    "submit": "جمع کروائیں۔",
    "suggestTime": "وقت تجویز کریں۔",
    "suggestedTime": "تجویز کردہ وقت",
    "support": "مدد و تعاون",
    "svc": "سروس",
    "sweep": "جھاڑو",
    "sweepFile": "سوئپ فائل",
    "table": "ٹیبل",
    "table-user": "ٹیبل صارف",
    "takeSignature": "دستخط لیں۔",
    "taxInformation": "ٹیکس کی معلومات",
    "taxonomyCode": "ٹیکسانومی کوڈ",
    "tbTest": "ٹی بی ٹیسٹ",
    "template": "سانچہ",
    "templateIsRequired": "سانچہ درکار ہے۔",
    "textAssistanceRequiredFor": "ممبر کے لیے ٹیکسٹ اسسٹنس درکار ہے۔",
    "textLiveLinkTo": "ممبر کو لائیو لنک ٹیکسٹ کریں۔",
    "thirdParty": "تھرڈ پارٹی",
    "thisOperationWillComplete": "یہ آپریشن انشورنس کلیم فائلوں جیسے ٹرپ لاگز، TRF فارم وغیرہ بنانے کے لیے درکار معلومات کو مکمل کرے گا۔",
    "threshold": "حد",
    "thresholdIsRequired": "حد درکار ہے۔",
    "timeCalibration": "وقت کیلیبریشن",
    "timeFormat": "وقت کی شکل",
    "timeFormatIsRequired": "وقت کی شکل درکار ہے۔",
    "timeIn": "وقت میں",
    "timeInAt": "وقت میں",
    "timeInIsRequired": "وقت درکار ہے۔",
    "timeLabel": "وقت",
    "timeOut": "ٹائم آؤٹ",
    "timeOutIsRequired": "ٹائم آؤٹ درکار ہے۔",
    "timeRequired": "وقت مطلوب ہے",
    "timeZone": "ٹائم زون",
    "timeZoneIsRequired": "ٹائم زون درکار ہے۔",
    "timein": "ٹائمین",
    "timeline": "ٹائم لائن",
    "timelines": "ٹائم لائنز",
    "times": "×",
    "tipStatusIsRequired": "ٹپ اسٹیٹس درکار ہے۔",
    "tipTitleIsRequired": "ٹپ ٹائٹل درکار ہے۔",
    "tiresInformation": "ٹائر کی معلومات",
    "title": "عنوان",
    "titleIsRequired": "عنوان درکار ہے۔",
    "tls": "tls",
    "to": "کو",
    "toIsRequired": "کی ضرورت ہے۔",
    "today": "آج",
    "toll-freeNumber": "ٹول فری نمبر",
    "toll-freeNumberIsRequired": "ٹول فری نمبر درکار ہے۔",
    "totalFare": "کل کرایہ",
    "totalFareIsRequired": "کل کرایہ درکار ہے۔",
    "tp": "(TP)",
    "traffic": "ٹریفک",
    "travelAndSequence": "سفر اور ترتیب",
    "trial": "آزمائش",
    "trialEnd": "آزمائش ختم",
    "tripAssistance": "ٹرپ اسسٹنس",
    "tripId": "ٹرپ آئی ڈی",
    "tripIdLabel": "ٹرپ آئی ڈی",
    "tripIdRequired": "ٹرپ آئی ڈی مطلوب ہے",
    "tripInformation": "سفر کی معلومات",
    "tripLogs": "ٹرپ لاگز",
    "tripQuota": "ٹرپ کوٹہ",
    "tripQuotaIsRequired": "ٹرپ کوٹہ درکار ہے۔",
    "tripReport": "ٹرپ رپورٹ",
    "tripRoute": "سفر کا راستہ",
    "tripS": "سفر",
    "tripSequenceLate": "ٹرپ ترتیب (دیر)",
    "tripSequenceOnTime": "ٹرپ ترتیب (وقت پر)",
    "tripStatus": "ٹرپ سٹیٹس",
    "tripWise": "ٹرپ وائز",
    "trips": "سفر",
    "tripsAdjustmentImportant": "سفر کی ایڈجسٹمنٹ (بینکنگ سے پہلے اہم)",
    "tripsFile": "ٹرپس فائل",
    "tripsFileIsRequired": "ٹرپس فائل درکار ہے۔",
    "tripsItinerary": "دوروں کا سفر نامہ",
    "tripsMapDashboard": "ٹرپس میپ ڈیش بورڈ",
    "type": "قسم",
    "typeAMessage": "ایک پیغام ٹائپ کریں.....",
    "un-selectAll": "تمام کو غیر منتخب کریں۔",
    "unassign": "تفویض ختم کریں۔",
    "unassigned": "غیر تفویض کردہ",
    "unassignedCancelled": "غیر تفویض شدہ منسوخ",
    "unassignedTrips": "غیر تفویض شدہ سفر",
    "unconfirm": "غیر تصدیق شدہ",
    "undo": "کالعدم",
    "unknown": "نامعلوم",
    "unloadTimeIsRequired": "اتارنے کا وقت درکار ہے۔",
    "unscheduled": "[غیر شیڈول]",
    "upBaseAddress": "اوپر کی بنیاد کا پتہ",
    "updateAssists": "اسسٹس کو اپ ڈیٹ کریں۔",
    "updateButton": "اپ ڈیٹ کریں",
    "updateStatus": "اسٹیٹس کو اپ ڈیٹ کریں۔",
    "uploadAFile": "ایک فائل اپ لوڈ کریں۔",
    "uploadAnImage": "ایک تصویر اپ لوڈ کریں۔",
    "uploadJpegJpgOr": ".jpeg، .jpg یا .png فائل اپ لوڈ کریں۔",
    "uploadTxtFile": "txt فائل اپ لوڈ کریں۔",
    "uploadXlsxXlsOr": ".xlsx، .xls یا .csv فائل اپ لوڈ کریں۔",
    "urduLanguageLabel": "اردو",
    "url": "URL",
    "useAPermanentAddress": "ایک مستقل پتہ استعمال کریں جہاں آپ میل وصول کر سکیں۔",
    "useAuthenticSignatures": "مستند دستخط استعمال کریں۔",
    "useMemberPermanentAddress": "ممبر کا مستقل پتہ استعمال کریں جہاں وہ میل وصول کر سکے۔",
    "useSettingAriaLabel": "ترتیبات کا استعمال کریں",
    "user": "صارف",
    "user-image": "صارف کی تصویر",
    "user-img": "صارف-img",
    "userPhoto": "صارف کی تصویر",
    "username": "صارف نام",
    "usernameIsRequired": "صارف نام درکار ہے۔",
    "users": "صارفین",
    "usingTheBelowForm": "نئے بروکر کنفیگریشن کو شامل کرنے کے لیے نیچے دیے گئے فارم کا استعمال کریں۔",
    "usingTheBelowForm2": "نئی ای میل کنفیگریشن شامل کرنے کے لیے نیچے دیے گئے فارم کا استعمال کریں۔",
    "v1": "V1",
    "v2": "V2",
    "v3": "V3",
    "validityRange": "درستگی کی حد",
    "validityRangeIsRequired": "درستگی کی حد درکار ہے۔",
    "vehicle": "گاڑی",
    "vehicleDecalNumberIs": "گاڑی کا ڈیکل نمبر درکار ہے۔",
    "vehicleGarage": "گاڑیوں کا گیراج",
    "vehicleIdentificationNumberI": "گاڑی کا شناختی نمبر درکار ہے۔",
    "vehicleImageBack": "گاڑی کی تصویر پیچھے",
    "vehicleImageFront": "گاڑی کی تصویر سامنے",
    "vehicleImageLeft": "گاڑی کی تصویر بائیں",
    "vehicleImageRight": "گاڑی کی تصویر دائیں طرف",
    "vehicleInspectionInPast": "پچھلے 12 مہینوں میں گاڑیوں کا معائنہ",
    "vehicleMakeIsRequired": "گاڑیاں بنانے کی ضرورت ہے۔",
    "vehicleRecordCheckDot": "گاڑیوں کا ریکارڈ چیک (DOT MVR)",
    "vehicleRecordCheckStandard": "گاڑی کا ریکارڈ چیک (معیاری چیک)",
    "vehicleServiceNumberIs": "گاڑی کا سروس نمبر درکار ہے۔",
    "vehicleTypeIsRequired": "گاڑی کی قسم درکار ہے۔",
    "vehicleWise": "وہیکل وائز",
    "vehiclesFleet": "گاڑیاں / فلیٹ",
    "verifyCode": "کوڈ کی تصدیق کریں۔",
    "viewRoute": "روٹ دیکھیں",
    "viewTripsOnly": "صرف ٹرپس دیکھیں",
    "vin": "VIN",
    "vinIsRequired": "VIN درکار ہے۔",
    "violationIsRequired": "خلاف ورزی ضروری ہے۔",
    "violationSets": "خلاف ورزی سیٹ",
    "vipExpiryDate": "VIP میعاد ختم ہونے کی تاریخ",
    "vipExpiryDateIs": "VIP کی میعاد ختم ہونے کی تاریخ درکار ہے۔",
    "vipLabel": "VIP",
    "vipMembers": "وی آئی پی ممبران",
    "virginia": "ورجینیا",
    "visit": "وزٹ کریں۔",
    "voicemail": "وائس میل",
    "waitTime": "انتظار کا وقت",
    "waitTimeCode": "وقت کا کوڈ انتظار کریں۔",
    "waitTimeCodeIs": "انتظار کے وقت کا کوڈ درکار ہے۔",
    "waitTimeIsRequired": "انتظار کا وقت درکار ہے۔",
    "wandererRisk": "وانڈرر رسک",
    "warning": "وارننگ",
    "weekendNightCode": "ویک اینڈ نائٹ کوڈ",
    "weekendNightCodeIs": "ویک اینڈ نائٹ کوڈ درکار ہے۔",
    "weeklyFee": "ہفتہ وار فیس",
    "weeklyFeeIsRequired": "ہفتہ وار فیس درکار ہے۔",
    "weightLabel": "وزن",
    "weightRequired": "وزن مطلوب ہے",
    "wheelchairRampInformation": "وہیل چیئر ریمپ کی معلومات",
    "wheelchairSecurementTraining": "وہیل چیئر کی حفاظت کی تربیت (EXP)",
    "widthIsRequired": "چوڑائی کی ضرورت ہے۔",
    "willCall": "ول کال",
    "willCall2359": "ول کال (23:59)",
    "willCallActivated": "ایکٹیویٹڈ کال کریں گے۔",
    "willCallBracket": "[ول کال]",
    "willCallLabel": "کال پر",
    "willCallTrip": "ٹرپ کو کال کریں گے۔",
    "wmrNumber": "ڈبلیو ایم آر نمبر",
    "wmrNumberIsRequired": "WMR نمبر درکار ہے۔",
    "writeYourCommentHere": "اپنا تبصرہ یہاں لکھیں...",
    "yamsolLlc": "YAMSOL LLC",
    "year": "سال",
    "yearIsRequired": "سال درکار ہے۔",
    "yes": "جی ہاں",
    "yourCompany": "آپ کی کمپنی",
    "yourLicenseIsGoing": "آپ کے لائسنس کی میعاد 22/11/2020 کو ختم ہو رہی ہے۔ کسی بھی قسم کی تکلیف سے بچنے کے لیے براہ کرم Hoosier ٹرانسپورٹیشن پر اپنے لائسنس کی تجدید اور اپ ڈیٹ کریں۔",
    "zipCode": "زپ کوڈ",
    "zipCodeIsRequired": "زپ کوڈ درکار ہے۔",
    "zipIsRequired": "زپ درکار ہے۔",
    "zoneForIsRequired": "زون کی ضرورت ہے۔",
    "zoneName": "زون کا نام",
    "zones": "علاقے",
    "zoom": "زوم",
    "id": "آئی ڈی",
    "escort": "مرافق",
    "spRate": "خصوصی شرح",
    "estFare": "اندازہ کرایہ",
    "createdTime": "تخلیق کا وقت",
    "authNumber": "اجازت نامہ نمبر",
    "appointmentTypes": "ملاقات کی اقسام",
    "dvNotes": "ڈرائیور نوٹس",
    "source": "ذریعہ",
    "trackingNo": "ٹریکنگ نمبر",
    "roleOrSource": "کردار/ذریعہ",
    "staffManager": "اسٹاف مینیجر",
    "mobileNumber": "موبائل نمبر",
    "updatedAt": "تاریخ کی تازہ کاری",
    "createdAt": "تخلیق شدہ وقت",
    "version": "ورژن",
    "shiftLabel": "شفٹ",
    "role": "کردار",
    "puTime": "پک اپ کا وقت",
    "doTime": "ڈراپ آف کا وقت",
    "puDate": "پک اپ کی تاریخ",
    "doDate": "ڈراپ آف کی تاریخ",
    "memberInfo": "ممبر کی معلومات",
    "facilityVeh": "سہولت - گاڑی",
    "noMemberName": "نمبر/ممبر کا نام",
    "dosLabel": "تاریخِ خدمت",
    "losLabel": "سروس کا لیول",
    "pickupTime": "پک اپ کا وقت",
    "dropoffTime": "ڈراپ آف کا وقت",
    "mileage": "مائلیج",
    "reservationNoLabel": "ریزرویشن نمبر",
    "claimed": "دعویٰ کیا گیا",
    "onboardStatus": "آن بورڈ حیثیت",
    "insurance": "انشورنس",
    "loadTime": "لوڈ ٹائم",
    "unloadTime": "اتارنے کا وقت",
    "totalTrips": "کل ٹرپس",
    "totalIntake": "کل انٹیک",
    "serviceCharges": "سروس چارجز",
    "companyIntake": "کمپنی انٹیک",
    "remainingAmount": "باقی رقم",
    "cashPayment": "نقد ادائیگی",
    "creditPayment": "کریڈٹ ادائیگی",
    "adjustedAmount": "ایڈجسٹ شدہ رقم",
    "balance": "بیلنس",
    "driverEarnings": "ڈرائیور کی کمائی",
    "earnings": "کمائی",
    "cash": "نقد",
    "credit": "کریڈٹ",
    "adjusted": "ایڈجسٹ",
    "total": "کل",
    "early": "جلدی",
    "onTime": "وقت پر",
    "late": "دیر",
    "earlyTimeScore": "ابتدائی وقت کا سکور",
    "onTimeScore": "وقت پر سکور",
    "lateTimeScore": "تاخیر سے آنے والے وقت کا سکور",
    "actualOnTimeScore": "اصل وقت پر سکور",
    "aptTime": "ملاقات کا وقت",
    "arrivedTime": "پہنچنے کا وقت",
    "message": "پیغام",
    "error": "غلطی",
    "sentDate": "بھیجنے کی تاریخ",
    "createdDate": "تخلیق کی تاریخ",
    "memberId": "ممبر آئی ڈی",
    "otpStatus": "او ٹی پی کی حیثیت",
    "otpMinutes": "او ٹی پی منٹس",
    "oneHourViolation": "1 گھنٹے کی خلاف ورزی",
    "filePath": "فائل کا راستہ",
    "mrnLabel": "ممبر ریکارڈ نمبر (MRN)",
    "timestamps": "ٹائم اسٹیمپ",
    "trackId": "ٹریک آئی ڈی",
    "location": "مقام",
    "report": "رپورٹ",
    "currentMileage": "موجودہ مائلیج",
    "inspectedBy": "کی طرف سے معائنہ کیا گیا",
    "inspectionCenter": "معائنہ مرکز",
    "result": "نتیجہ",
    "passed": "پاس",
    "failed": "فیل",
    "dateCorrected": "درست کرنے کی تاریخ",
    "frontDriverPassengerCompartment": "فرنٹ ڈرائیور / مسافر کمپارٹمنٹ",
    "patientCompartment": "مریض کا کمپارٹمنٹ",
    "exteriorVehicle": "خارجی گاڑی",
    "underHoodCompartment": "ہڈ / کمپارٹمنٹ کے نیچے",
    "fluidsEngine": "سیال / انجن",
    "brakeTest": "بریک ٹیسٹ",
    "tiresWheels": "ٹائر / پہیے",
    "brakes": "بریک",
    "bodyFrame": "باڈی اور فریم",
    "fuelSystem": "فیول سسٹم",
    "exhaustSystem": "ایگزاسٹ سسٹم",
    "cost": "لاگت",
    "category": "زمرہ",
    "shiftTime": "شفٹ کا وقت",
    "timeInTimeOut": "ٹائم ان/ٹائم آؤٹ",
    "mealTakenDue": "کھانا لیا/باقی",
    "restTakenDue": "آرام لیا/باقی",
    "workingHours": "کام کے اوقات",
    "breakHours": "وقفے کے اوقات",
    "loadedMilesRate": "لوڈڈ میل ریٹ",
    "deadMilesRate": "خالی میل ریٹ",
    "account": "اکاؤنٹ",
    "amount": "رقم",
    "approxDo": "~ڈراپ آف",
    "approxPu": "~پک اپ",
    "approxTimeLabel": "تخمینی وقت",
    "approxPuLabel": "تخمینی پک اپ",
    "approxDoLabel": "تخمینی ڈراپ آف",
    "currentTrip": "موجودہ سفر",
    "appt": "اپائنٹمنٹ",
    "arrive": "آمد",
    "arriveDist": "آمد فاصلہ",
    "availability": "دستیابی",
    "breaksAck": "بریکس تصدیق",
    "breaksDue": "بریکس واجب",
    "breaksTaken": "بریکس لی گئی",
    "bucket": "بالٹی",
    "bumped": "منسوخ/موخر",
    "cads": "کیڈز",
    "cancelCharge": "منسوخی چارج",
    "cancelledTrips": "منسوخ سفر",
    "changeReason": "تبدیلی کی وجہ",
    "claimAmount": "کلیم رقم",
    "claimId": "کلیم آئی ڈی",
    "claimPaymentAmount": "کلیم ادائیگی رقم",
    "company": "کمپنی",
    "companyIntakeAfterThreshold": "حد کے بعد کمپنی حصہ",
    "completedTrips": "مکمل سفر",
    "components": "اجزاء",
    "dateLabel": "تاریخ",
    "day": "دن",
    "declined": "مسترد",
    "distDiff": "فاصلہ فرق",
    "distance": "فاصلہ",
    "distanceViolet": "فاصلہ خلاف ورزی",
    "doAddress": "ڈراپ آف پتہ",
    "driverIntakeAfterThreshold": "حد کے بعد ڈرائیور حصہ",
    "dropoffDiff": "ڈراپ آف فرق",
    "duration": "مدت",
    "engaged": "مصروف",
    "eta": "متوقع وقت",
    "events": "ایونٹس",
    "fee": "فیس",
    "flatFee": "فلیٹ فیس",
    "fromTime": "وقت سے",
    "group": "گروپ",
    "ignored": "نظر انداز",
    "lateReason": "تاخیر کی وجہ",
    "loadUnloadTime": "لوڈ/ان لوڈ وقت",
    "loadedMiles": "لوڈڈ میلز",
    "maxFactor": "زیادہ سے زیادہ فیکٹر",
    "minimumFare": "کم از کم کرایہ",
    "netProfit": "خالص منافع",
    "newDist": "نیا فاصلہ",
    "noOfTrips": "سفر کی تعداد",
    "noShowCharge": "نو شو چارج",
    "odometerStartEnd": "اوڈومیٹر شروع-اختتام",
    "onboardViolet": "آن بورڈ خلاف ورزی",
    "otherViolet": "دیگر خلاف ورزی",
    "outgoings": "آؤٹ گوئنگ",
    "passedFailed": "پاس/فیل",
    "patientName": "مریض کا نام",
    "pdOrder": "پک اپ/ڈراپ آرڈر",
    "perform": "انجام دہی",
    "performDist": "انجام دہی فاصلہ",
    "phone": "فون",
    "phoneNo": "فون نمبر",
    "pickupDiff": "پک اپ فرق",
    "platformCharges": "پلیٹ فارم چارجز:",
    "preDist": "پہلا فاصلہ",
    "price": "قیمت",
    "puAddress": "پک اپ پتہ",
    "puDoAddress": "پک اپ - ڈراپ پتہ",
    "remaining": "باقی",
    "restHours": "آرام کے گھنٹے",
    "returned": "واپس",
    "rigHash": "رگ #",
    "rigType": "رگ قسم",
    "service": "سروس",
    "serviceDate": "سروس کی تاریخ",
    "sr": "نمبر",
    "srHash": "نمبر#",
    "status": "حالت",
    "timeDifference": "وقت کا فرق",
    "timeStamps": "وقت کی مہر",
    "timeWise": "وقت کے مطابق",
    "tip": "ٹپ",
    "toTime": "وقت تک",
    "toll": "ٹول",
    "totalDeadMileRate": "کل خالی میل ریٹ",
    "totalEarning": "کل آمدنی",
    "totalEarningsColon": "کل آمدنی:",
    "totalLoadedMileRate": "کل لوڈڈ میل ریٹ",
    "travel": "سفر",
    "tripEarnings": "سفر کی آمدنی",
    "willCallStatus": "ول کال حالت",
    "adjustTrips": "سفر ایڈجسٹ کریں",
    "amendmentReq": "ترمیم کی درخواست",
    "assistRequired": "مدد درکار ہے؟",
    "associateTo": "منسوب کریں",
    "broker": "بروکر",
    "calculate": "حساب کریں",
    "clientIdMemberId": "کلائنٹ آئی ڈی / ممبر آئی ڈی / MA# / AHCCCS#",
    "displayName": "ظاہری نام",
    "documentExpiry": "دستاویز ختم",
    "driverGrievanceReport": "ڈرائیور شکایت رپورٹ",
    "driverSignature": "ڈرائیور دستخط",
    "generalInformation": "عام معلومات",
    "generateReport": "رپورٹ بنائیں",
    "googleApproximation": "گوگل تخمینہ",
    "localApproximation": "مقامی تخمینہ",
    "ltiReport": "LTI رپورٹ",
    "markConfirmed": "تصدیق شدہ نشان زد کریں",
    "markReady": "تیار نشان زد کریں",
    "unmarkReady": "تیار کا نشان ہٹائیں",
    "markUnassigned": "غیر تفویض نشان زد کریں",
    "markVoicemail": "وائس میل نشان زد کریں",
    "milesReport": "میل رپورٹ",
    "modifierTwo": "موڈیفائر دو",
    "otherReason": "دیگر وجہ",
    "partialEdit": "جزوی ترمیم",
    "plusAdd": "+ شامل کریں",
    "rating": "درجہ بندی",
    "rawTripSummary": "خام سفر خلاصہ",
    "receiverEmail": "وصول کنندہ ای میل",
    "state": "ریاست",
    "tripsReport": "سفر کی رپورٹ",
    "update": "اپ ڈیٹ",
    "showing": "دکھا رہا ہے",
    "entries": "اندراجات",
    "enterInPercent": "فیصد میں درج کریں",
    "enterInPercentage": "فیصد میں درج کریں",
    "selectCorporatePlaceholder": "-- کارپوریٹ منتخب کریں --",
    "grievance": "شکایت",
    "itemLost": "آئٹم گم",
    "generalShift": "جنرل شفٹ",
    "addCorporate": "کارپوریٹ شامل کریں",
    "addCompanies": "کمپنیاں شامل کریں",
    "Accidental Reports": "حادثہ رپورٹس",
    "Addons": "ایڈونز",
    "Announcements": "اعلانات",
    "Appointment Types": "اپائنٹمنٹ ٹائپس",
    "Billing": "بلنگ",
    "Business Reports": "بزنس رپورٹس",
    "CheckList": "چیک لسٹ",
    "Dashboard": "ڈیش بورڈ",
    "Availability": "دستیابی",
    "Dirt Road": "گندے راستے",
    "Driver Alerts": "ڈرائیور الرٹس",
    "Driver Expense": "ڈرائیور اخراجات",
    "Driver Score": "ڈرائیور سکور",
    "Driver Wise": "ڈرائیور وائز",
    "EDI 835": "EDI 835",
    "Earnings": "آمدنی",
    "Extras": "اضافی",
    "Fleet": "فلیٹ",
    "Grievance / Item Lost": "شکایت / گم شدہ آئٹم",
    "Helping Material": "مددگار مواد",
    "Invoice": "انوائس",
    "Itineries": "آئٹنریز",
    "Maintenance": "مینٹیننس",
    "Manifest": "مینيفیسٹ",
    "Manual": "مینوئل",
    "Modifier Codes": "موڈیفائر کوڈز",
    "Nemt Pro Tips": "NEMT پرو ٹپس",
    "Operations": "آپریشنز",
    "Outbounding": "آؤٹ باؤنڈنگ",
    "Planner": "پلانر",
    "Primary Diagnosis": "پرائمری ڈائیگنوسس",
    "Pro Tips": "پرو ٹپس",
    "Push to Talk": "پش ٹو ٹاک",
    "Rates": "ریٹس",
    "Reports": "رپورٹس",
    "Routing": "روٹنگ",
    "SMS": "ایس ایم ایس",
    "Statistics": "اعدادوشمار",
    "Support": "سپورٹ",
    "TRFs & Claims": "TRFs اور کلیمز",
    "TRFs Templates": "TRFs ٹیمپلیٹس",
    "Trips": "سفر",
    "Vehicle Expense": "گاڑی کے اخراجات",
    "Vehicle Inspection": "گاڑی کا معائنہ",
    "Zones": "زونز",
    "back": "واپس",
    "next": "اگلا",
    "previous": "پچھلا",
    "upload": "اپ لوڈ",
    "export": "ایکسپورٹ",
    "import": "درآمد",
    "refresh": "ریفریش",
    "edit": "ترمیم",
    "view": "دیکھیں",
    "loading": "لوڈ ہو رہا ہے",
    "deselectAll": "سب غیر منتخب",
    "more": "مزید...",
    "clearFilters": "فلٹرز صاف کریں",
    "clearFilter": "فلٹر صاف کریں",
    "clearAll": "سب صاف کریں",
    "applyFilters": "فلٹرز لگائیں",
    "applyFilter": "فلٹر لگائیں",
    "noData": "کوئی ڈیٹا نہیں",
    "noResults": "کوئی نتیجہ نہیں",
    "ok": "ٹھیک ہے",
    "filters": "فلٹرز",
    "Staging": "اسٹیجنگ",
    "Assigned": "تفویض شدہ",

    "memberInfoHeader": "ممبر کی معلومات",
    "serviceInfoHeader": "سروس کی معلومات",
    "dateTimeHeader": "تاریخ اور وقت",
    "pickupTimeLabel": "پک اپ کا وقت",
    "dropoffTimeLabel": "ڈراپ آف کا وقت",
    "cityLabel": "شہر",
    "stateLabel": "ریاست",
    "zipCodeLabel": "زپ کوڈ",
    "notesHeader": "نوٹس",
    "attachmentsHeader": "منسلکات",
    "paymentStatus": "ادائیگی کی حیثیت",
    "assistedBy": "کی طرف سے مدد:",
    "insuranceId": "انشورنس شناختی کارڈ",
    "ipaNumber": "آئی پی اے نمبر",
    "passengerName": "مسافر کا نام",
    "cellPhone": "سیل فون",
    "dob": "تاریخ پیدائش",
    "clientId": "کلائنٹ کی شناخت",
    "forDriver": "ڈرائیور کے لیے",
    "actualMiles": "اصل میل",
    "paymentMode": "طریقہ ادائیگی",
    "deadMinutes": "ڈیڈ منٹس",
    "tripMiles": "سفر کے میل",
    "tripTime": "سفر کا وقت",
    "totalTripMiles": "کل سفر کے میل",
    "totalTripTime": "کل سفر کا وقت",
    "totalTripMilesInclDeadMiles": "کل سفر کے میل (بشمول ڈیڈ میل)",
    "totalTripTimeInclDeadMinutes": "کل سفر کا وقت (بشمول ڈیڈ منٹس)",
    "odometerEnd": "اوڈومیٹر اختتام",
    "enRoute": "راستے میں",
    "readySince": "تیار از:",
    "app": "ایپ",
    "availabilityDays": "دستیابی کے دن",
    "joiningDate": "شمولیت کی تاریخ",
    "sunday": "اتوار",
    "sun": "اتوار",
    "monday": "پیر",
    "mon": "پیر",
    "tuesday": "منگل",
    "tue": "منگل",
    "wednesday": "بدھ",
    "wed": "بدھ",
    "thursday": "جمعرات",
    "thu": "جمعرات",
    "friday": "جمعہ",
    "fri": "جمعہ",
    "saturday": "ہفتہ",
    "sat": "ہفتہ",
    "dayMon": "پیر",
    "dayTue": "منگل",
    "dayWed": "بدھ",
    "dayThu": "جمعرات",
    "dayFri": "جمعہ",
    "daySat": "ہفتہ",
    "daySun": "اتوار",
    "addressPicker": "پتہ منتخب کریں",
    "smsConfiguration": "ایس ایم ایس کنفیگریشن",
    "confirmationTemplate": "تصدیقی ٹیمپلیٹ",
    "default": "ڈیفالٹ",
    "boldage": "Boldage"
};
